export const displayUnitData = [
    {
        id:     'Active Air Changes',
        value:  'Air Changes Per Hour (ACH)',
        unitId: '43badf12-29ea-411e-b119-270ae9ca28f7'
    },
    { 
        id:     'Active Air Changes Setpoint',
        value:  'Air Changes Per Hour (ACH)',
        unitId: '43badf12-29ea-411e-b119-270ae9ca28f7'
    },
    { 
        id:     'Air Filter Alarm Status',
        value:  'Alarm',
        unitId: null
    },
    { 
        id:     'Air Filter Alarm Status Enum',
        value:  'Alarm',
        unitId: null
    },
    { 
        id:     'Air Filter Alarm Text',
        value:  'Alarm',
        unitId: null
    },
    { 
        id:     'Air Filter Differential Pressure',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Air Filter Differential Pressure High Limit',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Air Filter Differential Pressure Low Limit',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Air Prefilter Alarm Status',
        value:  'Alarm',
        unitId: null
    },
    { 
        id:     'Air Prefilter Alarm Status Enum',
        value:  'Alarm',
        unitId: null
    },
    { 
        id:     'Air Prefilter Alarm Text',
        value:  'Alarm',
        unitId: null
    },
    { 
        id:     'Air Prefilter Differential Pressure',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Air Prefilter Differential Pressure High Limit',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Air Prefilter Differential Pressure Low Limit',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Alarm Status',
        value:  'Alarm',
        unitId: null
    },
    { 
        id:     'Alarm Status 1',
        value:  'Alarm',
        unitId: null
    },
    { 
        id:     'Alarm Status 2',
        value:  'Alarm',
        unitId: null
    },
    { 
        id:     'Alarm Status 3',
        value:  'Alarm',
        unitId: null
    },
    { 
        id:     'Alarm Status 4',
        value:  'Alarm',
        unitId: null
    },
    { 
        id:     'Alarm Status 5',
        value:  'Alarm',
        unitId: null
    },
    { 
        id:     'Alarm Status 6',
        value:  'Alarm',
        unitId: null
    },
    { 
        id:     'Alarm Status Enum',
        value:  'Alarm',
        unitId: null
    },
    { 
        id:     'Alarm Text',
        value:  'Alarm',
        unitId: null
    },
    { 
        id:     'Boiler 1 Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Boiler 1 Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Boiler 2 Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Boiler 2 Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Boiler 3 Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Boiler 3 Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Boiler 4 Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Boiler 4 Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Boiler Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Boiler Flame Failure',
        value:  'Alarm',
        unitId: null
    },
    { 
        id:     'Boiler Low Limit',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Boiler Low Water',
        value:  'Alarm',
        unitId: null
    },
    { 
        id:     'Boiler PMP Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Boiler Pump 1 Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Boiler Pump 1 Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Boiler Pump 2 Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Boiler Pump 2 Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Boiler Pump Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Boiler Pump Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Boiler Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Bypass Damper Open Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Bypass Damper Open Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Bypass Damper Position',
        value:  'Percentage (%)',
        unitId: 'bd1f4749-9598-4c27-b879-073e6783a775'
    },
    { 
        id:     'Bypass Damper Position Command',
        value:  'Percentage (%)',
        unitId: 'bd1f4749-9598-4c27-b879-073e6783a775'
    },
    { 
        id:     'Bypass Damper Position Max Command',
        value:  'Percentage (%)',
        unitId: 'bd1f4749-9598-4c27-b879-073e6783a775'
    },
    { 
        id:     'Bypass Damper Position Min Command',
        value:  'Percentage (%)',
        unitId: 'bd1f4749-9598-4c27-b879-073e6783a775'
    },
    { 
        id:     'Bypass Valve Open Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Bypass Valve Open Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Bypass Valve Position',
        value:  'Percentage (%)',
        unitId: 'bd1f4749-9598-4c27-b879-073e6783a775'
    },
    { 
        id:     'Bypass Valve Position Command',
        value:  'Percentage (%)',
        unitId: 'bd1f4749-9598-4c27-b879-073e6783a775'
    },
    { 
        id:     'Bypass Valve Position Max Command',
        value:  'Percentage (%)',
        unitId: 'bd1f4749-9598-4c27-b879-073e6783a775'
    },
    { 
        id:     'Bypass Valve Position Min Command',
        value:  'Percentage (%)',
        unitId: 'bd1f4749-9598-4c27-b879-073e6783a775'
    },
    { 
        id:     'Capacity',
        value:  'Percentage (%)',
        unitId: 'bd1f4749-9598-4c27-b879-073e6783a775'
    },
    { 
        id:     'Capacity Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Capacity Max Command',
        value:  'Percentage (%)',
        unitId: 'bd1f4749-9598-4c27-b879-073e6783a775'
    },
    { 
        id:     'Capacity Min Command',
        value:  'Percentage (%)',
        unitId: 'bd1f4749-9598-4c27-b879-073e6783a775'
    },
    { 
        id:     'Chilled Water Approach',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Chilled Water Delta T',
        value:  'Unitless ()',
        unitId: 'e9301189-9503-4ef1-aa07-72a14d949688'
    },
    { 
        id:     'Chiller Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Chiller Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Coefficient of Performance',
        value:  'Unitless ()',
        unitId: 'e9301189-9503-4ef1-aa07-72a14d949688'
    },
    { 
        id:     'Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Communication Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Communication Status Enum',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Communication Text',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Compressed Air Pressure',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Compressed Air Pressure Deviation',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Compressed Air Pressure High Limit',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Compressed Air Pressure Low Limit',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Compressed Air Pressure Max Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Compressed Air Pressure Min Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Compressed Air Pressure Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Compressor 1 Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Compressor 1 Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Compressor 2 Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Compressor 2 Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Compressor 3 Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Compressor 3 Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Compressor 4 Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Compressor 4 Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Compressor 5 Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Compressor 5 Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Compressor 6 Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Compressor 6 Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Compressor Capacity',
        value:  'Percentage (%)',
        unitId: 'bd1f4749-9598-4c27-b879-073e6783a775'
    },
    { 
        id:     'Compressor Capacity Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Compressor Capacity Max Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Compressor Capacity Min Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Compressor Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Compressor Current',
        value:  'Ampere (A)',
        unitId: '07515d1e-c260-42d9-81b5-cfd65c66d7cf'
    },
    { 
        id:     'Compressor Electric Usage',
        value:  'Kilowatt Hour (KWh)',
        unitId: 'eb844ee5-8420-4829-b57e-daa8547f5e3c'
    },
    { 
        id:     'Compressor Entering Refrigerant Pressure',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Compressor Entering Refrigerant Pressure Deviation',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Compressor Entering Refrigerant Pressure High Limit',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Compressor Entering Refrigerant Pressure Low Limit',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Compressor Entering Refrigerant Pressure Low Limit Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Compressor Entering Refrigerant Pressure Max Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Compressor Entering Refrigerant Pressure Min Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Compressor Entering Refrigerant Pressure Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Compressor Entering Refrigerant Temperature',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Compressor Entering Refrigerant Temperature Deviation',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Compressor Entering Refrigerant Temperature High Limit',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Compressor Entering Refrigerant Temperature Low Limit',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Compressor Entering Refrigerant Temperature Max Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Compressor Entering Refrigerant Temperature Min Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Compressor Entering Refrigerant Temperature Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Compressor Frequency',
        value:  'Hertz (Hz)',
        unitId: 'e4ef5692-143b-4102-9cd3-b3cc4ce0216b'
    },
    { 
        id:     'Compressor Horsepower',
        value:  'Horsepower (Hp)',
        unitId: 'bb7650f1-d12e-4253-9efb-7b6d3867cda5'
    },
    { 
        id:     'Compressor Leaving Refrigerant Pressure',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Compressor Leaving Refrigerant Pressure Deviation',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Compressor Leaving Refrigerant Pressure High Limit',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Compressor Leaving Refrigerant Pressure High Limit Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Compressor Leaving Refrigerant Pressure Low Limit',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Compressor Leaving Refrigerant Pressure Max Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Compressor Leaving Refrigerant Pressure Min Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Compressor Leaving Refrigerant Pressure Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Compressor Leaving Refrigerant Temperature',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Compressor Leaving Refrigerant Temperature Deviation',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Compressor Leaving Refrigerant Temperature High Limit',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Compressor Leaving Refrigerant Temperature Low Limit',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Compressor Leaving Refrigerant Temperature Max Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Compressor Leaving Refrigerant Temperature Min Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Compressor Leaving Refrigerant Temperature Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Compressor Oil Heater Current',
        value:  'Ampere (A)',
        unitId: '07515d1e-c260-42d9-81b5-cfd65c66d7cf'
    },
    { 
        id:     'Compressor Oil Heater Electric Usage',
        value:  'Kilowatt Hour (KWh)',
        unitId: 'eb844ee5-8420-4829-b57e-daa8547f5e3c'
    },
    { 
        id:     'Compressor Oil Heater Frequency',
        value:  'Hertz (Hz)',
        unitId: 'e4ef5692-143b-4102-9cd3-b3cc4ce0216b'
    },
    { 
        id:     'Compressor Oil Heater Horsepower',
        value:  'Horsepower (Hp)',
        unitId: 'bb7650f1-d12e-4253-9efb-7b6d3867cda5'
    },
    { 
        id:     'Compressor Oil Heater Power',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Compressor Oil Heater Power Factor',
        value:  'Unitless ()',
        unitId: 'e9301189-9503-4ef1-aa07-72a14d949688'
    },
    { 
        id:     'Compressor Oil Heater Resistance',
        value:  'Ohm (Î©)',
        unitId: 'd41dc7fc-608c-4048-bcc4-42a9afe8ec61'
    },
    { 
        id:     'Compressor Oil Heater Runtime',
        value:  'Second (Sec)',
        unitId: 'b0f5c0ad-8643-489b-90f7-f0a75fc4fe76'
    },
    { 
        id:     'Compressor Oil Heater Starts',
        value:  'Unitless ()',
        unitId: 'e9301189-9503-4ef1-aa07-72a14d949688'
    },
    { 
        id:     'Compressor Oil Heater Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Compressor Oil Heater Voltage',
        value:  'Volt (V)',
        unitId: 'ceffcac4-ab75-4906-9207-7b4693b304ef'
    },
    { 
        id:     'Compressor Oil Level',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Compressor Oil Pressure',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Compressor Oil Pressure Deviation',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Compressor Oil Pressure High Limit',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Compressor Oil Pressure Low Limit',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Compressor Oil Pressure Max Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Compressor Oil Pressure Min Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Compressor Oil Pressure Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Compressor Oil Pump Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Compressor Oil Pump Current',
        value:  'Ampere (A)',
        unitId: '07515d1e-c260-42d9-81b5-cfd65c66d7cf'
    },
    { 
        id:     'Compressor Oil Pump Electric Usage',
        value:  'Kilowatt Hour (KWh)',
        unitId: 'eb844ee5-8420-4829-b57e-daa8547f5e3c'
    },
    { 
        id:     'Compressor Oil Pump Frequency',
        value:  'Hertz (Hz)',
        unitId: 'e4ef5692-143b-4102-9cd3-b3cc4ce0216b'
    },
    { 
        id:     'Compressor Oil Pump Horsepower',
        value:  'Horsepower (Hp)',
        unitId: 'bb7650f1-d12e-4253-9efb-7b6d3867cda5'
    },
    { 
        id:     'Compressor Oil Pump Power',
        value:  'Kilowatt (KW)',
        unitId: 'f147c894-0c59-41ad-85ec-f26b5a6315cf'
    },
    { 
        id:     'Compressor Oil Pump Power Factor',
        value:  'Unitless ()',
        unitId: 'e9301189-9503-4ef1-aa07-72a14d949688'
    },
    { 
        id:     'Compressor Oil Pump Resistance',
        value:  'Ohm (Î©)',
        unitId: 'd41dc7fc-608c-4048-bcc4-42a9afe8ec61'
    },
    { 
        id:     'Compressor Oil Pump RPM',
        value:  'Revolutions Per Minute (Rpm)',
        unitId: '20ede1b5-acbc-40fa-b2f5-f9864c750533'
    },
    { 
        id:     'Compressor Oil Pump Runtime',
        value:  'Second (Sec)',
        unitId: 'b0f5c0ad-8643-489b-90f7-f0a75fc4fe76'
    },
    { 
        id:     'Compressor Oil Pump Speed',
        value:  'Revolutions Per Minute (Rpm)',
        unitId: '20ede1b5-acbc-40fa-b2f5-f9864c750533'
    },
    { 
        id:     'Compressor Oil Pump Speed Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Compressor Oil Pump Speed Max Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Compressor Oil Pump Speed Min Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Compressor Oil Pump Starts',
        value:  'Unitless ()',
        unitId: 'e9301189-9503-4ef1-aa07-72a14d949688'
    },
    { 
        id:     'Compressor Oil Pump Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Compressor Oil Pump Voltage',
        value:  'Volt (V)',
        unitId: 'ceffcac4-ab75-4906-9207-7b4693b304ef'
    },
    { 
        id:     'Compressor Oil Temperature',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Compressor Oil Temperature Deviation',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Compressor Oil Temperature High Limit',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Compressor Oil Temperature Low Limit',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Compressor Oil Temperature Max Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Compressor Oil Temperature Min Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Compressor Oil Temperature Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Compressor Power',
        value:  'Kilowatt (KW)',
        unitId: 'f147c894-0c59-41ad-85ec-f26b5a6315cf'
    },
    { 
        id:     'Compressor Power Factor',
        value:  'Unitless ()',
        unitId: 'e9301189-9503-4ef1-aa07-72a14d949688'
    },
    { 
        id:     'Compressor Resistance',
        value:  'Ohm (Î©)',
        unitId: 'd41dc7fc-608c-4048-bcc4-42a9afe8ec61'
    },
    { 
        id:     'Compressor RPM',
        value:  'Revolutions Per Minute (Rpm)',
        unitId: '20ede1b5-acbc-40fa-b2f5-f9864c750533'
    },
    { 
        id:     'Compressor Runtime',
        value:  'Second (Sec)',
        unitId: 'b0f5c0ad-8643-489b-90f7-f0a75fc4fe76'
    },
    { 
        id:     'Compressor Starts',
        value:  'Unitless ()',
        unitId: 'e9301189-9503-4ef1-aa07-72a14d949688'
    },
    { 
        id:     'Compressor Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Compressor Voltage',
        value:  'Volt (V)',
        unitId: 'ceffcac4-ab75-4906-9207-7b4693b304ef'
    },
    { 
        id:     'Condenser Approach',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Condenser Entering Refrigerant Pressure',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Condenser Entering Refrigerant Pressure Deviation',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Condenser Entering Refrigerant Pressure High Limit',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Condenser Entering Refrigerant Pressure Low Limit',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Condenser Entering Refrigerant Pressure Max Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Condenser Entering Refrigerant Pressure Min Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Condenser Entering Refrigerant Pressure Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Condenser Entering Refrigerant Temperature',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Condenser Entering Refrigerant Temperature Deviation',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Condenser Entering Refrigerant Temperature High Limit',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Condenser Entering Refrigerant Temperature Low Limit',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Condenser Entering Refrigerant Temperature Max Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Condenser Entering Refrigerant Temperature Min Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Condenser Entering Refrigerant Temperature Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Condenser Entering Water Flow',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Condenser Entering Water Flow Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Condenser Entering Water Pressure',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Condenser Entering Water Pressure High Limit',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Condenser Entering Water Pressure Low Limit',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Condenser Entering Water Temperature',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Condenser Entering Water Temperature High Limit',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Condenser Entering Water Temperature Low Limit',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Condenser Entering Water Temperature Sensor',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Condenser Entering Water Temperature Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Condenser Fan Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Condenser Fan Current',
        value:  'Ampere (A)',
        unitId: '07515d1e-c260-42d9-81b5-cfd65c66d7cf'
    },
    { 
        id:     'Condenser Fan Electric Usage',
        value:  'Kilowatt Hour (KWh)',
        unitId: 'eb844ee5-8420-4829-b57e-daa8547f5e3c'
    },
    { 
        id:     'Condenser Fan Frequency',
        value:  'Hertz (Hz)',
        unitId: 'e4ef5692-143b-4102-9cd3-b3cc4ce0216b'
    },
    { 
        id:     'Condenser Fan Horsepower',
        value:  'Horsepower (Hp)',
        unitId: 'bb7650f1-d12e-4253-9efb-7b6d3867cda5'
    },
    { 
        id:     'Condenser Fan Power',
        value:  'Kilowatt (KW)',
        unitId: 'f147c894-0c59-41ad-85ec-f26b5a6315cf'
    },
    { 
        id:     'Condenser Fan Power Factor',
        value:  'Unitless ()',
        unitId: 'e9301189-9503-4ef1-aa07-72a14d949688'
    },
    { 
        id:     'Condenser Fan Resistance',
        value:  'Ohm (Î©)',
        unitId: 'd41dc7fc-608c-4048-bcc4-42a9afe8ec61'
    },
    { 
        id:     'Condenser Fan RPM',
        value:  'Revolutions Per Minute (Rpm)',
        unitId: '20ede1b5-acbc-40fa-b2f5-f9864c750533'
    },
    { 
        id:     'Condenser Fan Runtime',
        value:  'Second (Sec)',
        unitId: 'b0f5c0ad-8643-489b-90f7-f0a75fc4fe76'
    },
    { 
        id:     'Condenser Fan Speed',
        value:  'Revolutions Per Minute (Rpm)',
        unitId: '20ede1b5-acbc-40fa-b2f5-f9864c750533'
    },
    { 
        id:     'Condenser Fan Speed Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Condenser Fan Speed Max Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Condenser Fan Speed Min Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Condenser Fan Starts',
        value:  'Unitless ()',
        unitId: 'e9301189-9503-4ef1-aa07-72a14d949688'
    },
    { 
        id:     'Condenser Fan Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Condenser Fan Voltage',
        value:  'Volt (V)',
        unitId: 'ceffcac4-ab75-4906-9207-7b4693b304ef'
    },
    { 
        id:     'Condenser Leaving Refrigerant Pressure',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Condenser Leaving Refrigerant Pressure Deviation',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Condenser Leaving Refrigerant Pressure High Limit',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Condenser Leaving Refrigerant Pressure Low Limit',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Condenser Leaving Refrigerant Pressure Max Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Condenser Leaving Refrigerant Pressure Min Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Condenser Leaving Refrigerant Pressure Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Condenser Leaving Refrigerant Temperature',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Condenser Leaving Refrigerant Temperature Deviation',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Condenser Leaving Refrigerant Temperature High Limit',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Condenser Leaving Refrigerant Temperature Low Limit',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Condenser Leaving Refrigerant Temperature Max Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Condenser Leaving Refrigerant Temperature Min Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Condenser Leaving Refrigerant Temperature Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Condenser Leaving Water Flow',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Condenser Leaving Water Flow Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Condenser Leaving Water Pressure',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Condenser Leaving Water Pressure High Limit',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Condenser Leaving Water Pressure Low Limit',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Condenser Leaving Water Temperature',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Condenser Leaving Water Temperature High Limit',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Condenser Leaving Water Temperature Low Limit',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Condenser Leaving Water Temperature Sensor',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Condenser Leaving Water Temperature Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Condenser Saturated Refrigerant Pressure',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Condenser Saturated Refrigerant Pressure Deviation',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Condenser Saturated Refrigerant Pressure High Limit',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Condenser Saturated Refrigerant Pressure Low Limit',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Condenser Saturated Refrigerant Pressure Max Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Condenser Saturated Refrigerant Pressure Min Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Condenser Saturated Refrigerant Pressure Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Condenser Saturated Refrigerant Temperature',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Condenser Saturated Refrigerant Temperature 1',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Condenser Saturated Refrigerant Temperature 2',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Condenser Saturated Refrigerant Temperature 3',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Condenser Saturated Refrigerant Temperature 4',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Condenser Saturated Refrigerant Temperature 5',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Condenser Saturated Refrigerant Temperature Deviation',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Condenser Saturated Refrigerant Temperature High Limit',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Condenser Saturated Refrigerant Temperature Low Limit',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Condenser Saturated Refrigerant Temperature Max Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Condenser Saturated Refrigerant Temperature Min Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Condenser Saturated Refrigerant Temperature Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Condenser Water Approach',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Condenser Water Delta T',
        value:  'Unitless ()',
        unitId: 'e9301189-9503-4ef1-aa07-72a14d949688'
    },
    { 
        id:     'Condenser Water Pump Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Condenser Water Pump Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Cool Down Mode Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Cool Down Mode Off Setpoint',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Cool Down Mode On Setpoint',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Cool Down Mode Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Cooling Air CO',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Cooling Air CO Deviation',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Cooling Air CO High Limit',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Cooling Air CO Max Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Cooling Air CO Min Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Cooling Air CO Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Cooling Air CO2',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Cooling Air CO2 Deviation',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Cooling Air CO2 High Limit',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Cooling Air CO2 Max Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Cooling Air CO2 Min Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Cooling Air CO2 Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Cooling Air Dewpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Cooling Air Dewpoint High Limit',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Cooling Air Dewpoint Low Limit',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Cooling Air Dewpoint Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Cooling Air Enthalpy',
        value:  'Btu Per Pound (BTU/Lb)',
        unitId: 'd9a10744-cdfb-48af-8766-6238d86a8aae'
    },
    { 
        id:     'Cooling Air Enthalpy Deviation',
        value:  'Btu Per Pound (BTU/Lb)',
        unitId: 'd9a10744-cdfb-48af-8766-6238d86a8aae'
    },
    { 
        id:     'Cooling Air Enthalpy Max Setpoint',
        value:  'Btu Per Pound (BTU/Lb)',
        unitId: 'd9a10744-cdfb-48af-8766-6238d86a8aae'
    },
    { 
        id:     'Cooling Air Enthalpy Min Setpoint',
        value:  'Btu Per Pound (BTU/Lb)',
        unitId: 'd9a10744-cdfb-48af-8766-6238d86a8aae'
    },
    { 
        id:     'Cooling Air Enthalpy Setpoint',
        value:  'Btu Per Pound (BTU/Lb)',
        unitId: 'd9a10744-cdfb-48af-8766-6238d86a8aae'
    },
    { 
        id:     'Cooling Air Flow',
        value:  'Cubic Feet Per Minute (Cfm)',
        unitId: '13a96208-b342-46fe-b293-5c5395768b01'
    },
    { 
        id:     'Cooling Air Flow Deviation',
        value:  'Cubic Feet Per Minute (Cfm)',
        unitId: '13a96208-b342-46fe-b293-5c5395768b01'
    },
    { 
        id:     'Cooling Air Flow Max Setpoint',
        value:  'Cubic Feet Per Minute (Cfm)',
        unitId: '13a96208-b342-46fe-b293-5c5395768b01'
    },
    { 
        id:     'Cooling Air Flow Min Setpoint',
        value:  'Cubic Feet Per Minute (Cfm)',
        unitId: '13a96208-b342-46fe-b293-5c5395768b01'
    },
    { 
        id:     'Cooling Air Flow Setpoint',
        value:  'Cubic Feet Per Minute (Cfm)',
        unitId: '13a96208-b342-46fe-b293-5c5395768b01'
    },
    { 
        id:     'Cooling Air Flow Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Cooling Air Methane',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Cooling Air Methane Deviation',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Cooling Air Methane High Limit',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Cooling Air Methane Max Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Cooling Air Methane Min Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Cooling Air Methane Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Cooling Air O2',
        value:  'Percentage (%)',
        unitId: 'bd1f4749-9598-4c27-b879-073e6783a775'
    },
    { 
        id:     'Cooling Air O2 Deviation',
        value:  'Percentage (%)',
        unitId: 'bd1f4749-9598-4c27-b879-073e6783a775'
    },
    { 
        id:     'Cooling Air O2 Max Setpoint',
        value:  'Percentage (%)',
        unitId: 'bd1f4749-9598-4c27-b879-073e6783a775'
    },
    { 
        id:     'Cooling Air O2 Min Setpoint',
        value:  'Percentage (%)',
        unitId: 'bd1f4749-9598-4c27-b879-073e6783a775'
    },
    { 
        id:     'Cooling Air O2 Setpoint',
        value:  'Percentage (%)',
        unitId: 'bd1f4749-9598-4c27-b879-073e6783a775'
    },
    { 
        id:     'Cooling Air PM2.5',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Cooling Air PM2.5 Deviation',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Cooling Air PM2.5 High Limit',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Cooling Air PM2.5 Max Setpoint',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Cooling Air PM2.5 Min Setpoint',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Cooling Air PM2.5 Setpoint',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Cooling Air Pressure',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Cooling Air Pressure Deviation',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Cooling Air Pressure High Limit',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Cooling Air Pressure Low Limit',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Cooling Air Pressure Max Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Cooling Air Pressure Min Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Cooling Air Pressure Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Cooling Air Relative Humidity',
        value:  'Percent Relative Humidity (%RH)',
        unitId: '219d3f18-210d-448f-9bd8-814a496f6f94'
    },
    { 
        id:     'Cooling Air Relative Humidity Deviation',
        value:  'Percent Relative Humidity (%RH)',
        unitId: '219d3f18-210d-448f-9bd8-814a496f6f94'
    },
    { 
        id:     'Cooling Air Relative Humidity High Limit',
        value:  'Percent Relative Humidity (%RH)',
        unitId: '219d3f18-210d-448f-9bd8-814a496f6f94'
    },
    { 
        id:     'Cooling Air Relative Humidity Low Limit',
        value:  'Percent Relative Humidity (%RH)',
        unitId: '219d3f18-210d-448f-9bd8-814a496f6f94'
    },
    { 
        id:     'Cooling Air Relative Humidity Max Setpoint',
        value:  'Percent Relative Humidity (%RH)',
        unitId: '219d3f18-210d-448f-9bd8-814a496f6f94'
    },
    { 
        id:     'Cooling Air Relative Humidity Min Setpoint',
        value:  'Percent Relative Humidity (%RH)',
        unitId: '219d3f18-210d-448f-9bd8-814a496f6f94'
    },
    { 
        id:     'Cooling Air Relative Humidity Setpoint',
        value:  'Percent Relative Humidity (%RH)',
        unitId: '219d3f18-210d-448f-9bd8-814a496f6f94'
    },
    { 
        id:     'Cooling Air Temperature',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Cooling Air Temperature Deviation',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Cooling Air Temperature High Limit',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Cooling Air Temperature Low Limit',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Cooling Air Temperature Max Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Cooling Air Temperature Min Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Cooling Air Temperature Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Cooling Air TVOC',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Cooling Air TVOC Deviation',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Cooling Air TVOC High Limit',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Cooling Air TVOC Max Setpoint',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Cooling Air TVOC Min Setpoint',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Cooling Air TVOC Setpoint',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Cooling Air Wet Bulb',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Cooling Air Wet Bulb High Limit',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Cooling Air Wet Bulb Low Limit',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Cooling Damper Open Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Cooling Damper Open Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Cooling Damper Position',
        value:  'Percentage (%)',
        unitId: 'bd1f4749-9598-4c27-b879-073e6783a775'
    },
    { 
        id:     'Cooling Damper Position Command',
        value:  'Percentage (%)',
        unitId: 'bd1f4749-9598-4c27-b879-073e6783a775'
    },
    { 
        id:     'Cooling Damper Position Max Command',
        value:  'Percentage (%)',
        unitId: 'bd1f4749-9598-4c27-b879-073e6783a775'
    },
    { 
        id:     'Cooling Damper Position Min Command',
        value:  'Percentage (%)',
        unitId: 'bd1f4749-9598-4c27-b879-073e6783a775'
    },
    { 
        id:     'Cooling Load',
        value:  'Percentage (%)',
        unitId: 'bd1f4749-9598-4c27-b879-073e6783a775'
    },
    { 
        id:     'Cooling Mode Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Cooling Mode Off Setpoint',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Cooling Mode On Setpoint',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Cooling Mode Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Cooling Stage',
        value:  'Percentage (%)',
        unitId: 'bd1f4749-9598-4c27-b879-073e6783a775'
    },
    { 
        id:     'Cooling Stage 1 Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Cooling Stage 1 Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Cooling Stage 2 Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Cooling Stage 2 Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Cooling Stage 3 Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Cooling Stage 3 Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Cooling Stage 4 Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Cooling Stage 4 Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Cooling Stage 5 Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Cooling Stage 5 Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Cooling Stage 6 Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Cooling Stage 6 Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Cooling Stage Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Cooling Stage Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Cooling Tower Basin Temperature Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Cooling Tower Entering Water Temperature Sensor',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Cooling Tower Entering Water Temperature Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Cooling Tower Fan Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Cooling Tower Fan Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Cooling Tower Leaving Water Temperature Sensor',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Cooling Tower Leaving Water Temperature Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Cooling Valve Open Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Cooling Valve Open Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Cooling Valve Position',
        value:  'Percentage (%)',
        unitId: 'bd1f4749-9598-4c27-b879-073e6783a775'
    },
    { 
        id:     'Cooling Valve Position Command',
        value:  'Percentage (%)',
        unitId: 'bd1f4749-9598-4c27-b879-073e6783a775'
    },
    { 
        id:     'Cooling Valve Position Max Command',
        value:  'Percentage (%)',
        unitId: 'bd1f4749-9598-4c27-b879-073e6783a775'
    },
    { 
        id:     'Cooling Valve Position Min Command',
        value:  'Percentage (%)',
        unitId: 'bd1f4749-9598-4c27-b879-073e6783a775'
    },
    { 
        id:     'Current',
        value:  'Ampere (A)',
        unitId: '07515d1e-c260-42d9-81b5-cfd65c66d7cf'
    },
    { 
        id:     'Daytime Warmup Mode Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Daytime Warmup Mode Off Setpoint',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Daytime Warmup Mode On Setpoint',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Daytime Warmup Mode Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Defrost Mode Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Defrost Mode Off Setpoint',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Defrost Mode On Setpoint',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Defrost Mode Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Dehumidification Mode Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Dehumidification Mode Off Setpoint',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Dehumidification Mode On Setpoint',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Dehumidification Mode Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Design Capacity',
        value:  'Percentage (%)',
        unitId: 'bd1f4749-9598-4c27-b879-073e6783a775'
    },
    { 
        id:     'Differential Air Pressure',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Differential Air Pressure Deviation',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Differential Air Pressure High Limit',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Differential Air Pressure Low Limit',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Differential Air Pressure Max Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Differential Air Pressure Min Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Differential Air Pressure Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Differential Air Temperature',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Differential Air Temperature High Limit',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Differential Air Temperature Low Limit',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Differential Steam Pressure',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Differential Steam Pressure Deviation',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Differential Steam Pressure High Limit',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Differential Steam Pressure Low Limit',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Differential Steam Pressure Max Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Differential Steam Pressure Min Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Differential Steam Pressure Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Differential Water Pressure',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Differential Water Pressure Deviation',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Differential Water Pressure High Limit',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Differential Water Pressure Low Limit',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Differential Water Pressure Max Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Differential Water Pressure Min Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Differential Water Pressure Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Differential Water Temperature',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Differential Water Temperature High Limit',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Differential Water Temperature Low Limit',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Door Open Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Door Open Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Drain Pan Alarm Status',
        value:  'Alarm',
        unitId: null
    },
    { 
        id:     'Drain Pan Alarm Status Enum',
        value:  'Alarm',
        unitId: null
    },
    { 
        id:     'Drain Pan Alarm Text',
        value:  'Alarm',
        unitId: null
    },
    { 
        id:     'Dual Temp Valve Open Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Dual Temp Valve Open Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Dual Temp Valve Position',
        value:  'Percentage (%)',
        unitId: 'bd1f4749-9598-4c27-b879-073e6783a775'
    },
    { 
        id:     'Dual Temp Valve Position Command',
        value:  'Percentage (%)',
        unitId: 'bd1f4749-9598-4c27-b879-073e6783a775'
    },
    { 
        id:     'Dual Temp Valve Position Max Command',
        value:  'Percentage (%)',
        unitId: 'bd1f4749-9598-4c27-b879-073e6783a775'
    },
    { 
        id:     'Dual Temp Valve Position Min Command',
        value:  'Percentage (%)',
        unitId: 'bd1f4749-9598-4c27-b879-073e6783a775'
    },
    { 
        id:     'DX Compressor Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'DX Compressor Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Economizer Damper Open Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Economizer Damper Open Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Economizer Damper Position',
        value:  'Percentage (%)',
        unitId: 'bd1f4749-9598-4c27-b879-073e6783a775'
    },
    { 
        id:     'Economizer Damper Position Command',
        value:  'Percentage (%)',
        unitId: 'bd1f4749-9598-4c27-b879-073e6783a775'
    },
    { 
        id:     'Economizer Damper Position Max Command',
        value:  'Percentage (%)',
        unitId: 'bd1f4749-9598-4c27-b879-073e6783a775'
    },
    { 
        id:     'Economizer Damper Position Min Command',
        value:  'Percentage (%)',
        unitId: 'bd1f4749-9598-4c27-b879-073e6783a775'
    },
    { 
        id:     'Economizer Fan Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Economizer Fan Current',
        value:  'Ampere (A)',
        unitId: '07515d1e-c260-42d9-81b5-cfd65c66d7cf'
    },
    { 
        id:     'Economizer Fan Electric Usage',
        value:  'Kilowatt Hour (KWh)',
        unitId: 'eb844ee5-8420-4829-b57e-daa8547f5e3c'
    },
    { 
        id:     'Economizer Fan Frequency',
        value:  'Hertz (Hz)',
        unitId: 'e4ef5692-143b-4102-9cd3-b3cc4ce0216b'
    },
    { 
        id:     'Economizer Fan Horsepower',
        value:  'Horsepower (Hp)',
        unitId: 'bb7650f1-d12e-4253-9efb-7b6d3867cda5'
    },
    { 
        id:     'Economizer Fan Power',
        value:  'Kilowatt (KW)',
        unitId: 'f147c894-0c59-41ad-85ec-f26b5a6315cf'
    },
    { 
        id:     'Economizer Fan Power Factor',
        value:  'Unitless ()',
        unitId: 'e9301189-9503-4ef1-aa07-72a14d949688'
    },
    { 
        id:     'Economizer Fan Resistance',
        value:  'Ohm (Î©)',
        unitId: 'd41dc7fc-608c-4048-bcc4-42a9afe8ec61'
    },
    { 
        id:     'Economizer Fan RPM',
        value:  'Revolutions Per Minute (Rpm)',
        unitId: '20ede1b5-acbc-40fa-b2f5-f9864c750533'
    },
    { 
        id:     'Economizer Fan Runtime',
        value:  'Second (Sec)',
        unitId: 'b0f5c0ad-8643-489b-90f7-f0a75fc4fe76'
    },
    { 
        id:     'Economizer Fan Speed',
        value:  'Revolutions Per Minute (Rpm)',
        unitId: '20ede1b5-acbc-40fa-b2f5-f9864c750533'
    },
    { 
        id:     'Economizer Fan Speed Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Economizer Fan Speed Max Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Economizer Fan Speed Min Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Economizer Fan Starts',
        value:  'Unitless ()',
        unitId: 'e9301189-9503-4ef1-aa07-72a14d949688'
    },
    { 
        id:     'Economizer Fan Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Economizer Fan Voltage',
        value:  'Volt (V)',
        unitId: 'ceffcac4-ab75-4906-9207-7b4693b304ef'
    },
    { 
        id:     'Economizer Mode Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Economizer Mode Off Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Economizer Mode On Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Economizer Mode Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Effective Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Efficiency',
        value:  'Joule (J)',
        unitId: 'e5f1c8fd-c28f-4d0b-ae72-fe9a4141f35f'
    },
    { 
        id:     'Electric Usage',
        value:  'Kilowatt Hour (KWh)',
        unitId: 'eb844ee5-8420-4829-b57e-daa8547f5e3c'
    },
    { 
        id:     'Enable',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Entering Refrigerant Pressure',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Entering Refrigerant Pressure Deviation',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Entering Refrigerant Pressure High Limit',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Entering Refrigerant Pressure Low Limit',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Entering Refrigerant Pressure Max Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Entering Refrigerant Pressure Min Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Entering Refrigerant Pressure Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Entering Refrigerant Temperature',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Entering Refrigerant Temperature Deviation',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Entering Refrigerant Temperature High Limit',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Entering Refrigerant Temperature Low Limit',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Entering Refrigerant Temperature Max Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Entering Refrigerant Temperature Min Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Entering Refrigerant Temperature Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Evaporator Approach',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Evaporator Entering Refrigerant Pressure',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Evaporator Entering Refrigerant Pressure Deviation',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Evaporator Entering Refrigerant Pressure High Limit',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Evaporator Entering Refrigerant Pressure Low Limit',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Evaporator Entering Refrigerant Pressure Max Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Evaporator Entering Refrigerant Pressure Min Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Evaporator Entering Refrigerant Pressure Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Evaporator Entering Refrigerant Temperature',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Evaporator Entering Refrigerant Temperature 1',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Evaporator Entering Refrigerant Temperature 2',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Evaporator Entering Refrigerant Temperature 3',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Evaporator Entering Refrigerant Temperature 4',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Evaporator Entering Refrigerant Temperature 5',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Evaporator Entering Refrigerant Temperature Deviation',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Evaporator Entering Refrigerant Temperature High Limit',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Evaporator Entering Refrigerant Temperature Low Limit',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Evaporator Entering Refrigerant Temperature Max Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Evaporator Entering Refrigerant Temperature Min Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Evaporator Entering Refrigerant Temperature Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Evaporator Entering Water Temperature',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Evaporator Entering Water Temperature 1',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Evaporator Entering Water Temperature 2',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Evaporator Entering Water Temperature 3',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Evaporator Entering Water Temperature 4',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Evaporator Entering Water Temperature 5',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Evaporator Leaving Refrigerant Pressure',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Evaporator Leaving Refrigerant Pressure Deviation',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Evaporator Leaving Refrigerant Pressure High Limit',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Evaporator Leaving Refrigerant Pressure Low Limit',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Evaporator Leaving Refrigerant Pressure Max Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Evaporator Leaving Refrigerant Pressure Min Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Evaporator Leaving Refrigerant Pressure Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Evaporator Leaving Refrigerant Temperature',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Evaporator Leaving Refrigerant Temperature 1',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Evaporator Leaving Refrigerant Temperature 2',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Evaporator Leaving Refrigerant Temperature 3',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Evaporator Leaving Refrigerant Temperature 4',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Evaporator Leaving Refrigerant Temperature 5',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Evaporator Leaving Refrigerant Temperature Deviation',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Evaporator Leaving Refrigerant Temperature High Limit',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Evaporator Leaving Refrigerant Temperature Low Limit',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Evaporator Leaving Refrigerant Temperature Max Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Evaporator Leaving Refrigerant Temperature Min Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Evaporator Leaving Refrigerant Temperature Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Evaporator Leaving Water Temperature',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Evaporator Leaving Water Temperature 1',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Evaporator Leaving Water Temperature 2',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Evaporator Leaving Water Temperature 3',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Evaporator Leaving Water Temperature 4',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Evaporator Leaving Water Temperature 5',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Evaporator Saturated Refrigerant Pressure',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Evaporator Saturated Refrigerant Pressure Deviation',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Evaporator Saturated Refrigerant Pressure High Limit',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Evaporator Saturated Refrigerant Pressure Low Limit',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Evaporator Saturated Refrigerant Pressure Max Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Evaporator Saturated Refrigerant Pressure Min Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Evaporator Saturated Refrigerant Pressure Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Evaporator Saturated Refrigerant Temperature',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Evaporator Saturated Refrigerant Temperature Deviation',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Evaporator Saturated Refrigerant Temperature High Limit',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Evaporator Saturated Refrigerant Temperature Low Limit',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Evaporator Saturated Refrigerant Temperature Max Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Evaporator Saturated Refrigerant Temperature Min Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Evaporator Saturated Refrigerant Temperature Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Exhaust Air CO',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Exhaust Air CO High Limit',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Exhaust Air CO2',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Exhaust Air CO2 High Limit',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Exhaust Air Dewpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Exhaust Air Dewpoint High Limit',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Exhaust Air Dewpoint Low Limit',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Exhaust Air Dewpoint Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Exhaust Air Enthalpy',
        value:  'Btu Per Pound (BTU/Lb)',
        unitId: 'd9a10744-cdfb-48af-8766-6238d86a8aae'
    },
    { 
        id:     'Exhaust Air Enthalpy Deviation',
        value:  'Btu Per Pound (BTU/Lb)',
        unitId: 'd9a10744-cdfb-48af-8766-6238d86a8aae'
    },
    { 
        id:     'Exhaust Air Enthalpy Max Setpoint',
        value:  'Btu Per Pound (BTU/Lb)',
        unitId: 'd9a10744-cdfb-48af-8766-6238d86a8aae'
    },
    { 
        id:     'Exhaust Air Enthalpy Min Setpoint',
        value:  'Btu Per Pound (BTU/Lb)',
        unitId: 'd9a10744-cdfb-48af-8766-6238d86a8aae'
    },
    { 
        id:     'Exhaust Air Enthalpy Setpoint',
        value:  'Btu Per Pound (BTU/Lb)',
        unitId: 'd9a10744-cdfb-48af-8766-6238d86a8aae'
    },
    { 
        id:     'Exhaust Air Flow',
        value:  'Cubic Feet Per Minute (Cfm)',
        unitId: '13a96208-b342-46fe-b293-5c5395768b01'
    },
    { 
        id:     'Exhaust Air Flow Max Setpoint',
        value:  'Cubic Feet Per Minute (Cfm)',
        unitId: '13a96208-b342-46fe-b293-5c5395768b01'
    },
    { 
        id:     'Exhaust Air Flow Min Setpoint',
        value:  'Cubic Feet Per Minute (Cfm)',
        unitId: '13a96208-b342-46fe-b293-5c5395768b01'
    },
    { 
        id:     'Exhaust Air Flow Setpoint',
        value:  'Cubic Feet Per Minute (Cfm)',
        unitId: '13a96208-b342-46fe-b293-5c5395768b01'
    },
    { 
        id:     'Exhaust Air Flow Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Exhaust Air Methane',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Exhaust Air Methane High Limit',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Exhaust Air O2',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Exhaust Air PM2.5',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Exhaust Air PM2.5 High Limit',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Exhaust Air Pressure',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Exhaust Air Pressure High Limit',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Exhaust Air Pressure Low Limit',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Exhaust Air Pressure Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Exhaust Air Relative Humidity',
        value:  'Percent Relative Humidity (%RH)',
        unitId: '219d3f18-210d-448f-9bd8-814a496f6f94'
    },
    { 
        id:     'Exhaust Air Relative Humidity High Limit',
        value:  'Percent Relative Humidity (%RH)',
        unitId: '219d3f18-210d-448f-9bd8-814a496f6f94'
    },
    { 
        id:     'Exhaust Air Relative Humidity Low Limit',
        value:  'Percent Relative Humidity (%RH)',
        unitId: '219d3f18-210d-448f-9bd8-814a496f6f94'
    },
    { 
        id:     'Exhaust Air Temperature',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Exhaust Air Temperature High Limit',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Exhaust Air Temperature Low Limit',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Exhaust Air Temperature Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Exhaust Air TVOC',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Exhaust Air TVOC High Limit',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Exhaust Air Wet Bulb',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Exhaust Air Wet Bulb High Limit',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Exhaust Air Wet Bulb Low Limit',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Exhaust Damper Open Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Exhaust Damper Open Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Exhaust Damper Position',
        value:  'Percentage (%)',
        unitId: 'bd1f4749-9598-4c27-b879-073e6783a775'
    },
    { 
        id:     'Exhaust Damper Position Command',
        value:  'Percentage (%)',
        unitId: 'bd1f4749-9598-4c27-b879-073e6783a775'
    },
    { 
        id:     'Exhaust Damper Position Max Command',
        value:  'Percentage (%)',
        unitId: 'bd1f4749-9598-4c27-b879-073e6783a775'
    },
    { 
        id:     'Exhaust Damper Position Min Command',
        value:  'Percentage (%)',
        unitId: 'bd1f4749-9598-4c27-b879-073e6783a775'
    },
    { 
        id:     'Exhaust Fan Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Exhaust Fan Current',
        value:  'Ampere (A)',
        unitId: '07515d1e-c260-42d9-81b5-cfd65c66d7cf'
    },
    { 
        id:     'Exhaust Fan Electric Usage',
        value:  'Kilowatt Hour (KWh)',
        unitId: 'eb844ee5-8420-4829-b57e-daa8547f5e3c'
    },
    { 
        id:     'Exhaust Fan Frequency',
        value:  'Hertz (Hz)',
        unitId: 'e4ef5692-143b-4102-9cd3-b3cc4ce0216b'
    },
    { 
        id:     'Exhaust Fan Horsepower',
        value:  'Horsepower (Hp)',
        unitId: 'bb7650f1-d12e-4253-9efb-7b6d3867cda5'
    },
    { 
        id:     'Exhaust Fan Power',
        value:  'Kilowatt (KW)',
        unitId: 'f147c894-0c59-41ad-85ec-f26b5a6315cf'
    },
    { 
        id:     'Exhaust Fan Power Factor',
        value:  'Unitless ()',
        unitId: 'e9301189-9503-4ef1-aa07-72a14d949688'
    },
    { 
        id:     'Exhaust Fan Resistance',
        value:  'Ohm (Î©)',
        unitId: 'd41dc7fc-608c-4048-bcc4-42a9afe8ec61'
    },
    { 
        id:     'Exhaust Fan RPM',
        value:  'Revolutions Per Minute (Rpm)',
        unitId: '20ede1b5-acbc-40fa-b2f5-f9864c750533'
    },
    { 
        id:     'Exhaust Fan Runtime',
        value:  'Second (Sec)',
        unitId: 'b0f5c0ad-8643-489b-90f7-f0a75fc4fe76'
    },
    { 
        id:     'Exhaust Fan Speed',
        value:  'Revolutions Per Minute (Rpm)',
        unitId: '20ede1b5-acbc-40fa-b2f5-f9864c750533'
    },
    { 
        id:     'Exhaust Fan Speed Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Exhaust Fan Speed Max Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Exhaust Fan Speed Min Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Exhaust Fan Starts',
        value:  'Unitless ()',
        unitId: 'e9301189-9503-4ef1-aa07-72a14d949688'
    },
    { 
        id:     'Exhaust Fan Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Exhaust Fan Voltage',
        value:  'Volt (V)',
        unitId: 'ceffcac4-ab75-4906-9207-7b4693b304ef'
    },
    { 
        id:     'Expansion Valve Open Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Expansion Valve Open Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Expansion Valve Position',
        value:  'Percentage (%)',
        unitId: 'bd1f4749-9598-4c27-b879-073e6783a775'
    },
    { 
        id:     'Expansion Valve Position Command',
        value:  'Percentage (%)',
        unitId: 'bd1f4749-9598-4c27-b879-073e6783a775'
    },
    { 
        id:     'Expansion Valve Position Max Command',
        value:  'Percentage (%)',
        unitId: 'bd1f4749-9598-4c27-b879-073e6783a775'
    },
    { 
        id:     'Expansion Valve Position Min Command',
        value:  'Percentage (%)',
        unitId: 'bd1f4749-9598-4c27-b879-073e6783a775'
    },
    { 
        id:     'Fan High Speed Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Fan Low Speed Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Fan Medium Speed Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Fan Off Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Fan Speed Mode Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Filter Runtime',
        value:  'Second (Sec)',
        unitId: 'b0f5c0ad-8643-489b-90f7-f0a75fc4fe76'
    },
    { 
        id:     'Filter Runtime Setpoint',
        value:  'Second (Sec)',
        unitId: 'b0f5c0ad-8643-489b-90f7-f0a75fc4fe76'
    },
    { 
        id:     'Free Cooling Mode Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Free Cooling Mode Off Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Free Cooling Mode On Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Free Cooling Mode Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Freezestat Alarm Status',
        value:  'Alarm',
        unitId: null
    },
    { 
        id:     'Freezestat Alarm Status 1',
        value:  'Alarm',
        unitId: null
    },
    { 
        id:     'Freezestat Alarm Status 2',
        value:  'Alarm',
        unitId: null
    },
    { 
        id:     'Freezestat Alarm Status 3',
        value:  'Alarm',
        unitId: null
    },
    { 
        id:     'Freezestat Alarm Status 4',
        value:  'Alarm',
        unitId: null
    },
    { 
        id:     'Freezestat Alarm Status 5',
        value:  'Alarm',
        unitId: null
    },
    { 
        id:     'Freezestat Alarm Status Enum',
        value:  'Alarm',
        unitId: null
    },
    { 
        id:     'Freezestat Alarm Text',
        value:  'Alarm',
        unitId: null
    },
    { 
        id:     'Frequency',
        value:  'Hertz (Hz)',
        unitId: 'e4ef5692-143b-4102-9cd3-b3cc4ce0216b'
    },
    { 
        id:     'Fuel Flow',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Fuel Flow Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Fuel Level',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Fuel Pressure',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Fuel Pressure Deviation',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Fuel Pressure High Limit',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Fuel Pressure Low Limit',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Fuel Pressure Max Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Fuel Pressure Min Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Fuel Pressure Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Fuel Usage',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Gas Detector Alarm Status',
        value:  'Alarm',
        unitId: null
    },
    { 
        id:     'Gas Detector Alarm Status Enum',
        value:  'Alarm',
        unitId: null
    },
    { 
        id:     'Gas Detector Alarm Text',
        value:  'Alarm',
        unitId: null
    },
    { 
        id:     'Glycol Valve Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Heat Recovery Bypass Damper Open Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Heat Recovery Bypass Damper Open Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Heat Recovery Bypass Damper Position',
        value:  'Percentage (%)',
        unitId: 'bd1f4749-9598-4c27-b879-073e6783a775'
    },
    { 
        id:     'Heat Recovery Bypass Damper Position Command',
        value:  'Percentage (%)',
        unitId: 'bd1f4749-9598-4c27-b879-073e6783a775'
    },
    { 
        id:     'Heat Recovery Bypass Damper Position Max Command',
        value:  'Percentage (%)',
        unitId: 'bd1f4749-9598-4c27-b879-073e6783a775'
    },
    { 
        id:     'Heat Recovery Bypass Damper Position Min Command',
        value:  'Percentage (%)',
        unitId: 'bd1f4749-9598-4c27-b879-073e6783a775'
    },
    { 
        id:     'Heat Recovery Wheel Speed',
        value:  'Revolutions Per Minute (Rpm)',
        unitId: '20ede1b5-acbc-40fa-b2f5-f9864c750533'
    },
    { 
        id:     'Heat Recovery Wheel Speed Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Heat Recovery Wheel Speed Max Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Heat Recovery Wheel Speed Min Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Heat Recovery Wheel Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Heating Air CO',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Heating Air CO Deviation',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Heating Air CO High Limit',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Heating Air CO Max Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Heating Air CO Min Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Heating Air CO Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Heating Air CO2',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Heating Air CO2 Deviation',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Heating Air CO2 High Limit',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Heating Air CO2 Max Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Heating Air CO2 Min Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Heating Air CO2 Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Heating Air Dewpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Heating Air Dewpoint High Limit',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Heating Air Dewpoint Low Limit',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Heating Air Dewpoint Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Heating Air Enthalpy',
        value:  'Btu Per Pound (BTU/Lb)',
        unitId: 'd9a10744-cdfb-48af-8766-6238d86a8aae'
    },
    { 
        id:     'Heating Air Enthalpy Deviation',
        value:  'Btu Per Pound (BTU/Lb)',
        unitId: 'd9a10744-cdfb-48af-8766-6238d86a8aae'
    },
    { 
        id:     'Heating Air Enthalpy Max Setpoint',
        value:  'Btu Per Pound (BTU/Lb)',
        unitId: 'd9a10744-cdfb-48af-8766-6238d86a8aae'
    },
    { 
        id:     'Heating Air Enthalpy Min Setpoint',
        value:  'Btu Per Pound (BTU/Lb)',
        unitId: 'd9a10744-cdfb-48af-8766-6238d86a8aae'
    },
    { 
        id:     'Heating Air Enthalpy Setpoint',
        value:  'Btu Per Pound (BTU/Lb)',
        unitId: 'd9a10744-cdfb-48af-8766-6238d86a8aae'
    },
    { 
        id:     'Heating Air Flow',
        value:  'Cubic Feet Per Minute (Cfm)',
        unitId: '13a96208-b342-46fe-b293-5c5395768b01'
    },
    { 
        id:     'Heating Air Flow Deviation',
        value:  'Cubic Feet Per Minute (Cfm)',
        unitId: '13a96208-b342-46fe-b293-5c5395768b01'
    },
    { 
        id:     'Heating Air Flow Max Setpoint',
        value:  'Cubic Feet Per Minute (Cfm)',
        unitId: '13a96208-b342-46fe-b293-5c5395768b01'
    },
    { 
        id:     'Heating Air Flow Min Setpoint',
        value:  'Cubic Feet Per Minute (Cfm)',
        unitId: '13a96208-b342-46fe-b293-5c5395768b01'
    },
    { 
        id:     'Heating Air Flow Setpoint',
        value:  'Cubic Feet Per Minute (Cfm)',
        unitId: '13a96208-b342-46fe-b293-5c5395768b01'
    },
    { 
        id:     'Heating Air Flow Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Heating Air Methane',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Heating Air Methane Deviation',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Heating Air Methane High Limit',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Heating Air Methane Max Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Heating Air Methane Min Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Heating Air Methane Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Heating Air O2',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Heating Air O2 Deviation',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Heating Air O2 Max Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Heating Air O2 Min Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Heating Air O2 Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Heating Air PM2.5',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Heating Air PM2.5 Deviation',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Heating Air PM2.5 High Limit',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Heating Air PM2.5 Max Setpoint',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Heating Air PM2.5 Min Setpoint',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Heating Air PM2.5 Setpoint',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Heating Air Pressure',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Heating Air Pressure Deviation',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Heating Air Pressure High Limit',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Heating Air Pressure Low Limit',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Heating Air Pressure Max Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Heating Air Pressure Min Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Heating Air Pressure Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Heating Air Relative Humidity',
        value:  'Percent Relative Humidity (%RH)',
        unitId: '219d3f18-210d-448f-9bd8-814a496f6f94'
    },
    { 
        id:     'Heating Air Relative Humidity Deviation',
        value:  'Percent Relative Humidity (%RH)',
        unitId: '219d3f18-210d-448f-9bd8-814a496f6f94'
    },
    { 
        id:     'Heating Air Relative Humidity High Limit',
        value:  'Percent Relative Humidity (%RH)',
        unitId: '219d3f18-210d-448f-9bd8-814a496f6f94'
    },
    { 
        id:     'Heating Air Relative Humidity Low Limit',
        value:  'Percent Relative Humidity (%RH)',
        unitId: '219d3f18-210d-448f-9bd8-814a496f6f94'
    },
    { 
        id:     'Heating Air Relative Humidity Max Setpoint',
        value:  'Percent Relative Humidity (%RH)',
        unitId: '219d3f18-210d-448f-9bd8-814a496f6f94'
    },
    { 
        id:     'Heating Air Relative Humidity Min Setpoint',
        value:  'Percent Relative Humidity (%RH)',
        unitId: '219d3f18-210d-448f-9bd8-814a496f6f94'
    },
    { 
        id:     'Heating Air Relative Humidity Setpoint',
        value:  'Percent Relative Humidity (%RH)',
        unitId: '219d3f18-210d-448f-9bd8-814a496f6f94'
    },
    { 
        id:     'Heating Air Temperature',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Heating Air Temperature Deviation',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Heating Air Temperature High Limit',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Heating Air Temperature Low Limit',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Heating Air Temperature Max Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Heating Air Temperature Min Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Heating Air Temperature Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Heating Air TVOC',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Heating Air TVOC Deviation',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Heating Air TVOC High Limit',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Heating Air TVOC Max Setpoint',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Heating Air TVOC Min Setpoint',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Heating Air TVOC Setpoint',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Heating Air Wet Bulb',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Heating Air Wet Bulb High Limit',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Heating Air Wet Bulb Low Limit',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Heating Damper Open Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Heating Damper Open Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Heating Damper Position',
        value:  'Percentage (%)',
        unitId: 'bd1f4749-9598-4c27-b879-073e6783a775'
    },
    { 
        id:     'Heating Damper Position Command',
        value:  'Percentage (%)',
        unitId: 'bd1f4749-9598-4c27-b879-073e6783a775'
    },
    { 
        id:     'Heating Damper Position Max Command',
        value:  'Percentage (%)',
        unitId: 'bd1f4749-9598-4c27-b879-073e6783a775'
    },
    { 
        id:     'Heating Damper Position Min Command',
        value:  'Percentage (%)',
        unitId: 'bd1f4749-9598-4c27-b879-073e6783a775'
    },
    { 
        id:     'Heating Load',
        value:  'Percentage (%)',
        unitId: 'bd1f4749-9598-4c27-b879-073e6783a775'
    },
    { 
        id:     'Heating Mode Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Heating Mode Off Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Heating Mode On Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Heating Mode Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Heating Stage 1 Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Heating Stage 1 Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Heating Stage 2 Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Heating Stage 2 Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Heating Stage 3 Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Heating Stage 3 Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Heating Stage 4 Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Heating Stage 4 Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Heating Stage 5 Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Heating Stage 5 Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Heating Stage 6 Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Heating Stage 6 Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Heating Stage Capacity',
        value:  'Percentage (%)',
        unitId: 'bd1f4749-9598-4c27-b879-073e6783a775'
    },
    { 
        id:     'Heating Stage Capacity Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Heating Stage Capacity Max Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Heating Stage Capacity Min Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Heating Stage Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Heating Stage Current',
        value:  'Ampere (A)',
        unitId: '07515d1e-c260-42d9-81b5-cfd65c66d7cf'
    },
    { 
        id:     'Heating Stage Electric Usage',
        value:  'Kilowatt Hour (KWh)',
        unitId: 'eb844ee5-8420-4829-b57e-daa8547f5e3c'
    },
    { 
        id:     'Heating Stage Frequency',
        value:  'Hertz (Hz)',
        unitId: 'e4ef5692-143b-4102-9cd3-b3cc4ce0216b'
    },
    { 
        id:     'Heating Stage Horsepower',
        value:  'Horsepower (Hp)',
        unitId: 'bb7650f1-d12e-4253-9efb-7b6d3867cda5'
    },
    { 
        id:     'Heating Stage Power',
        value:  'Kilowatt (KW)',
        unitId: 'f147c894-0c59-41ad-85ec-f26b5a6315cf'
    },
    { 
        id:     'Heating Stage Power Factor',
        value:  'Unitless ()',
        unitId: 'e9301189-9503-4ef1-aa07-72a14d949688'
    },
    { 
        id:     'Heating Stage Resistance',
        value:  'Ohm (Î©)',
        unitId: 'd41dc7fc-608c-4048-bcc4-42a9afe8ec61'
    },
    { 
        id:     'Heating Stage Runtime',
        value:  'Second (Sec)',
        unitId: 'b0f5c0ad-8643-489b-90f7-f0a75fc4fe76'
    },
    { 
        id:     'Heating Stage Starts',
        value:  'Unitless ()',
        unitId: 'e9301189-9503-4ef1-aa07-72a14d949688'
    },
    { 
        id:     'Heating Stage Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Heating Stage Voltage',
        value:  'Volt (V)',
        unitId: 'ceffcac4-ab75-4906-9207-7b4693b304ef'
    },
    { 
        id:     'Heating Valve Open Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Heating Valve Open Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Heating Valve Position',
        value:  'Percentage (%)',
        unitId: 'bd1f4749-9598-4c27-b879-073e6783a775'
    },
    { 
        id:     'Heating Valve Position Command',
        value:  'Percentage (%)',
        unitId: 'bd1f4749-9598-4c27-b879-073e6783a775'
    },
    { 
        id:     'Heating Valve Position Max Command',
        value:  'Percentage (%)',
        unitId: 'bd1f4749-9598-4c27-b879-073e6783a775'
    },
    { 
        id:     'Heating Valve Position Min Command',
        value:  'Percentage (%)',
        unitId: 'bd1f4749-9598-4c27-b879-073e6783a775'
    },
    { 
        id:     'High Space Air Temperature Alarm',
        value:  'Alarm',
        unitId: null
    },
    { 
        id:     'High Static Pressure Alarm',
        value:  'Alarm',
        unitId: null
    },
    { 
        id:     'High Supply Air Temp Alarm',
        value:  'Alarm',
        unitId: null
    },
    { 
        id:     'High Supply Air Temperature Alarm',
        value:  'Alarm',
        unitId: null
    },
    { 
        id:     'Horsepower',
        value:  'Horsepower (Hp)',
        unitId: 'bb7650f1-d12e-4253-9efb-7b6d3867cda5'
    },
    { 
        id:     'Hot Gas Bypass Valve Open Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Hot Gas Bypass Valve Open Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Humidifier Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Humidifier Position',
        value:  'Percentage (%)',
        unitId: 'bd1f4749-9598-4c27-b879-073e6783a775'
    },
    { 
        id:     'Humidifier Position Command',
        value:  'Percentage (%)',
        unitId: 'bd1f4749-9598-4c27-b879-073e6783a775'
    },
    { 
        id:     'Humidifier Position Max Command',
        value:  'Percentage (%)',
        unitId: 'bd1f4749-9598-4c27-b879-073e6783a775'
    },
    { 
        id:     'Humidifier Position Min Command',
        value:  'Percentage (%)',
        unitId: 'bd1f4749-9598-4c27-b879-073e6783a775'
    },
    { 
        id:     'Humidifier Runtime',
        value:  'Second (Sec)',
        unitId: 'b0f5c0ad-8643-489b-90f7-f0a75fc4fe76'
    },
    { 
        id:     'Humidifier Starts',
        value:  'Unitless ()',
        unitId: 'e9301189-9503-4ef1-aa07-72a14d949688'
    },
    { 
        id:     'Humidifier Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Hydrogen Sensor',
        value:  'Kilograms Per Cubic Meter (Kg/MÂ³)',
        unitId: 'c254da08-8544-482f-bb66-b761f8bc9203'
    },
    { 
        id:     'Hydrogen Setpoint',
        value:  'Kilograms Per Cubic Meter (Kg/MÂ³)',
        unitId: 'c254da08-8544-482f-bb66-b761f8bc9203'
    },
    { 
        id:     'Ice Level',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Inlet Air Temp',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Inlet Air Temperature',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Inlet Guide Vanes Position',
        value:  'Percentage (%)',
        unitId: 'bd1f4749-9598-4c27-b879-073e6783a775'
    },
    { 
        id:     'ION Light Alarm Status',
        value:  'Alarm',
        unitId: null
    },
    { 
        id:     'Isolation Damper Open Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Isolation Damper Open Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Isolation Damper Position',
        value:  'Percentage (%)',
        unitId: 'bd1f4749-9598-4c27-b879-073e6783a775'
    },
    { 
        id:     'Isolation Damper Position Command',
        value:  'Percentage (%)',
        unitId: 'bd1f4749-9598-4c27-b879-073e6783a775'
    },
    { 
        id:     'Isolation Damper Position Max Command',
        value:  'Percentage (%)',
        unitId: 'bd1f4749-9598-4c27-b879-073e6783a775'
    },
    { 
        id:     'Isolation Damper Position Min Command',
        value:  'Percentage (%)',
        unitId: 'bd1f4749-9598-4c27-b879-073e6783a775'
    },
    { 
        id:     'Isolation Valve Open Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Isolation Valve Open Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Isolation Valve Position',
        value:  'Percentage (%)',
        unitId: 'bd1f4749-9598-4c27-b879-073e6783a775'
    },
    { 
        id:     'Isolation Valve Position Command',
        value:  'Percentage (%)',
        unitId: 'bd1f4749-9598-4c27-b879-073e6783a775'
    },
    { 
        id:     'Isolation Valve Position Max Command',
        value:  'Percentage (%)',
        unitId: 'bd1f4749-9598-4c27-b879-073e6783a775'
    },
    { 
        id:     'Isolation Valve Position Min Command',
        value:  'Percentage (%)',
        unitId: 'bd1f4749-9598-4c27-b879-073e6783a775'
    },
    { 
        id:     'Leaving Air Temp',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Leaving Air Temperature',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Leaving Refrigerant Pressure',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Leaving Refrigerant Pressure Deviation',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Leaving Refrigerant Pressure High Limit',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Leaving Refrigerant Pressure Low Limit',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Leaving Refrigerant Pressure Max Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Leaving Refrigerant Pressure Min Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Leaving Refrigerant Pressure Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Leaving Refrigerant Temperature',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Leaving Refrigerant Temperature Deviation',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Leaving Refrigerant Temperature High Limit',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Leaving Refrigerant Temperature Low Limit',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Leaving Refrigerant Temperature Max Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Leaving Refrigerant Temperature Min Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Leaving Refrigerant Temperature Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Light Level',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Local Space Air Temperature Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Local Space Temperature',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Low Space Air Temperature Alarm',
        value:  'Alarm',
        unitId: null
    },
    { 
        id:     'Low Static Pressure Alarm',
        value:  'Alarm',
        unitId: null
    },
    { 
        id:     'Low Supply Air Temp Alarm',
        value:  'Alarm',
        unitId: null
    },
    { 
        id:     'Low Supply Air Temperature Alarm',
        value:  'Alarm',
        unitId: null
    },
    { 
        id:     'Makeup Damper Open Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Makeup Damper Open Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Makeup Damper Position',
        value:  'Percentage (%)',
        unitId: 'bd1f4749-9598-4c27-b879-073e6783a775'
    },
    { 
        id:     'Makeup Damper Position Command',
        value:  'Percentage (%)',
        unitId: 'bd1f4749-9598-4c27-b879-073e6783a775'
    },
    { 
        id:     'Makeup Damper Position Max Command',
        value:  'Percentage (%)',
        unitId: 'bd1f4749-9598-4c27-b879-073e6783a775'
    },
    { 
        id:     'Makeup Damper Position Min Command',
        value:  'Percentage (%)',
        unitId: 'bd1f4749-9598-4c27-b879-073e6783a775'
    },
    { 
        id:     'Makeup Fan Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Makeup Fan Current',
        value:  'Ampere (A)',
        unitId: '07515d1e-c260-42d9-81b5-cfd65c66d7cf'
    },
    { 
        id:     'Makeup Fan Electric Usage',
        value:  'Kilowatt Hour (KWh)',
        unitId: 'eb844ee5-8420-4829-b57e-daa8547f5e3c'
    },
    { 
        id:     'Makeup Fan Frequency',
        value:  'Hertz (Hz)',
        unitId: 'e4ef5692-143b-4102-9cd3-b3cc4ce0216b'
    },
    { 
        id:     'Makeup Fan Horsepower',
        value:  'Horsepower (Hp)',
        unitId: 'bb7650f1-d12e-4253-9efb-7b6d3867cda5'
    },
    { 
        id:     'Makeup Fan Power',
        value:  'Kilowatt (KW)',
        unitId: 'f147c894-0c59-41ad-85ec-f26b5a6315cf'
    },
    { 
        id:     'Makeup Fan Power Factor',
        value:  'Unitless ()',
        unitId: 'e9301189-9503-4ef1-aa07-72a14d949688'
    },
    { 
        id:     'Makeup Fan Resistance',
        value:  'Ohm (Î©)',
        unitId: 'd41dc7fc-608c-4048-bcc4-42a9afe8ec61'
    },
    { 
        id:     'Makeup Fan RPM',
        value:  'Revolutions Per Minute (Rpm)',
        unitId: '20ede1b5-acbc-40fa-b2f5-f9864c750533'
    },
    { 
        id:     'Makeup Fan Runtime',
        value:  'Second (Sec)',
        unitId: 'b0f5c0ad-8643-489b-90f7-f0a75fc4fe76'
    },
    { 
        id:     'Makeup Fan Speed',
        value:  'Revolutions Per Minute (Rpm)',
        unitId: '20ede1b5-acbc-40fa-b2f5-f9864c750533'
    },
    { 
        id:     'Makeup Fan Speed Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Makeup Fan Speed Max Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Makeup Fan Speed Min Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Makeup Fan Starts',
        value:  'Unitless ()',
        unitId: 'e9301189-9503-4ef1-aa07-72a14d949688'
    },
    { 
        id:     'Makeup Fan Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Makeup Fan Voltage',
        value:  'Volt (V)',
        unitId: 'ceffcac4-ab75-4906-9207-7b4693b304ef'
    },
    { 
        id:     'Makeup Valve Open Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Makeup Valve Open Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Makeup Valve Position',
        value:  'Percentage (%)',
        unitId: 'bd1f4749-9598-4c27-b879-073e6783a775'
    },
    { 
        id:     'Makeup Valve Position Command',
        value:  'Percentage (%)',
        unitId: 'bd1f4749-9598-4c27-b879-073e6783a775'
    },
    { 
        id:     'Makeup Valve Position Max Command',
        value:  'Percentage (%)',
        unitId: 'bd1f4749-9598-4c27-b879-073e6783a775'
    },
    { 
        id:     'Makeup Valve Position Min Command',
        value:  'Percentage (%)',
        unitId: 'bd1f4749-9598-4c27-b879-073e6783a775'
    },
    { 
        id:     'Makeup Water Flow',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Makeup Water Flow Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Makeup Water Pressure',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Makeup Water Pressure High Limit',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Makeup Water Pressure Low Limit',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Makeup Water Temperature',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Makeup Water Temperature High Limit',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Makeup Water Temperature Low Limit',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Makeup Water Usage',
        value:  'Gallons Per Minute (Gal/Min)',
        unitId: '74497096-2815-426b-a708-c7b8e3e169b7'
    },
    { 
        id:     'Mechanical Cooling Mode Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Mechanical Cooling Mode Off Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Mechanical Cooling Mode On Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Mechanical Cooling Mode Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Methane Sensor',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Methane Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Mixed Air CO',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Mixed Air CO Deviation',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Mixed Air CO High Limit',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Mixed Air CO Max Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Mixed Air CO Min Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Mixed Air CO Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Mixed Air CO2',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Mixed Air CO2 Deviation',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Mixed Air CO2 High Limit',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Mixed Air CO2 Max Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Mixed Air CO2 Min Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Mixed Air CO2 Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Mixed Air Damper Open Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Mixed Air Damper Open Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Mixed Air Damper Position',
        value:  'Percentage (%)',
        unitId: 'bd1f4749-9598-4c27-b879-073e6783a775'
    },
    { 
        id:     'Mixed Air Damper Position Command',
        value:  'Percentage (%)',
        unitId: 'bd1f4749-9598-4c27-b879-073e6783a775'
    },
    { 
        id:     'Mixed Air Damper Position Max Command',
        value:  'Percentage (%)',
        unitId: 'bd1f4749-9598-4c27-b879-073e6783a775'
    },
    { 
        id:     'Mixed Air Damper Position Min Command',
        value:  'Percentage (%)',
        unitId: 'bd1f4749-9598-4c27-b879-073e6783a775'
    },
    { 
        id:     'Mixed Air Dewpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Mixed Air Dewpoint High Limit',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Mixed Air Dewpoint Low Limit',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Mixed Air Dewpoint Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Mixed Air Enthalpy',
        value:  'Btu Per Pound (BTU/Lb)',
        unitId: 'd9a10744-cdfb-48af-8766-6238d86a8aae'
    },
    { 
        id:     'Mixed Air Enthalpy Deviation',
        value:  'Btu Per Pound (BTU/Lb)',
        unitId: 'd9a10744-cdfb-48af-8766-6238d86a8aae'
    },
    { 
        id:     'Mixed Air Enthalpy Max Setpoint',
        value:  'Btu Per Pound (BTU/Lb)',
        unitId: 'd9a10744-cdfb-48af-8766-6238d86a8aae'
    },
    { 
        id:     'Mixed Air Enthalpy Min Setpoint',
        value:  'Btu Per Pound (BTU/Lb)',
        unitId: 'd9a10744-cdfb-48af-8766-6238d86a8aae'
    },
    { 
        id:     'Mixed Air Enthalpy Setpoint',
        value:  'Btu Per Pound (BTU/Lb)',
        unitId: 'd9a10744-cdfb-48af-8766-6238d86a8aae'
    },
    { 
        id:     'Mixed Air Fan Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Mixed Air Fan Current',
        value:  'Ampere (A)',
        unitId: '07515d1e-c260-42d9-81b5-cfd65c66d7cf'
    },
    { 
        id:     'Mixed Air Fan Electric Usage',
        value:  'Kilowatt Hour (KWh)',
        unitId: 'eb844ee5-8420-4829-b57e-daa8547f5e3c'
    },
    { 
        id:     'Mixed Air Fan Frequency',
        value:  'Hertz (Hz)',
        unitId: 'e4ef5692-143b-4102-9cd3-b3cc4ce0216b'
    },
    { 
        id:     'Mixed Air Fan Horsepower',
        value:  'Horsepower (Hp)',
        unitId: 'bb7650f1-d12e-4253-9efb-7b6d3867cda5'
    },
    { 
        id:     'Mixed Air Fan Power',
        value:  'Kilowatt (KW)',
        unitId: 'f147c894-0c59-41ad-85ec-f26b5a6315cf'
    },
    { 
        id:     'Mixed Air Fan Power Factor',
        value:  'Unitless ()',
        unitId: 'e9301189-9503-4ef1-aa07-72a14d949688'
    },
    { 
        id:     'Mixed Air Fan Resistance',
        value:  'Ohm (Î©)',
        unitId: 'd41dc7fc-608c-4048-bcc4-42a9afe8ec61'
    },
    { 
        id:     'Mixed Air Fan RPM',
        value:  'Revolutions Per Minute (Rpm)',
        unitId: '20ede1b5-acbc-40fa-b2f5-f9864c750533'
    },
    { 
        id:     'Mixed Air Fan Runtime',
        value:  'Second (Sec)',
        unitId: 'b0f5c0ad-8643-489b-90f7-f0a75fc4fe76'
    },
    { 
        id:     'Mixed Air Fan Speed',
        value:  'Revolutions Per Minute (Rpm)',
        unitId: '20ede1b5-acbc-40fa-b2f5-f9864c750533'
    },
    { 
        id:     'Mixed Air Fan Speed Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Mixed Air Fan Speed Max Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Mixed Air Fan Speed Min Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Mixed Air Fan Starts',
        value:  'Unitless ()',
        unitId: 'e9301189-9503-4ef1-aa07-72a14d949688'
    },
    { 
        id:     'Mixed Air Fan Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Mixed Air Fan Voltage',
        value:  'Volt (V)',
        unitId: 'ceffcac4-ab75-4906-9207-7b4693b304ef'
    },
    { 
        id:     'Mixed Air Flow',
        value:  'Cubic Feet Per Minute (Cfm)',
        unitId: '13a96208-b342-46fe-b293-5c5395768b01'
    },
    { 
        id:     'Mixed Air Flow Deviation',
        value:  'Cubic Feet Per Minute (Cfm)',
        unitId: '13a96208-b342-46fe-b293-5c5395768b01'
    },
    { 
        id:     'Mixed Air Flow Max Setpoint',
        value:  'Cubic Feet Per Minute (Cfm)',
        unitId: '13a96208-b342-46fe-b293-5c5395768b01'
    },
    { 
        id:     'Mixed Air Flow Min Setpoint',
        value:  'Cubic Feet Per Minute (Cfm)',
        unitId: '13a96208-b342-46fe-b293-5c5395768b01'
    },
    { 
        id:     'Mixed Air Flow Setpoint',
        value:  'Cubic Feet Per Minute (Cfm)',
        unitId: '13a96208-b342-46fe-b293-5c5395768b01'
    },
    { 
        id:     'Mixed Air Flow Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Mixed Air Methane',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Mixed Air Methane Deviation',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Mixed Air Methane High Limit',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Mixed Air Methane Max Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Mixed Air Methane Min Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Mixed Air Methane Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Mixed Air O2',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Mixed Air O2 Deviation',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Mixed Air O2 Max Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Mixed Air O2 Min Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Mixed Air O2 Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Mixed Air PM2.5',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Mixed Air PM2.5 Deviation',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Mixed Air PM2.5 High Limit',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Mixed Air PM2.5 Max Setpoint',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Mixed Air PM2.5 Min Setpoint',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Mixed Air PM2.5 Setpoint',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Mixed Air Pressure',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Mixed Air Pressure Deviation',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Mixed Air Pressure High Limit',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Mixed Air Pressure Low Limit',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Mixed Air Pressure Max Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Mixed Air Pressure Min Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Mixed Air Pressure Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Mixed Air Relative Humidity',
        value:  'Percent Relative Humidity (%RH)',
        unitId: '219d3f18-210d-448f-9bd8-814a496f6f94'
    },
    { 
        id:     'Mixed Air Relative Humidity Deviation',
        value:  'Percent Relative Humidity (%RH)',
        unitId: '219d3f18-210d-448f-9bd8-814a496f6f94'
    },
    { 
        id:     'Mixed Air Relative Humidity High Limit',
        value:  'Percent Relative Humidity (%RH)',
        unitId: '219d3f18-210d-448f-9bd8-814a496f6f94'
    },
    { 
        id:     'Mixed Air Relative Humidity Low Limit',
        value:  'Percent Relative Humidity (%RH)',
        unitId: '219d3f18-210d-448f-9bd8-814a496f6f94'
    },
    { 
        id:     'Mixed Air Relative Humidity Max Setpoint',
        value:  'Percent Relative Humidity (%RH)',
        unitId: '219d3f18-210d-448f-9bd8-814a496f6f94'
    },
    { 
        id:     'Mixed Air Relative Humidity Min Setpoint',
        value:  'Percent Relative Humidity (%RH)',
        unitId: '219d3f18-210d-448f-9bd8-814a496f6f94'
    },
    { 
        id:     'Mixed Air Relative Humidity Setpoint',
        value:  'Percent Relative Humidity (%RH)',
        unitId: '219d3f18-210d-448f-9bd8-814a496f6f94'
    },
    { 
        id:     'Mixed Air Temperature',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Mixed Air Temperature Deviation',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Mixed Air Temperature High Limit',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Mixed Air Temperature Low Limit',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Mixed Air Temperature Max Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Mixed Air Temperature Min Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Mixed Air Temperature Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Mixed Air Temperature Unoccupied Heating Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Mixed Air TVOC',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Mixed Air TVOC Deviation',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Mixed Air TVOC High Limit',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Mixed Air TVOC Max Setpoint',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Mixed Air TVOC Min Setpoint',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Mixed Air TVOC Setpoint',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Mixed Air Wet Bulb',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Mixed Air Wet Bulb High Limit',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Mixed Air Wet Bulb Low Limit',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Mode Command Enum',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Mode Status Enum',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Mode Text',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Morning Warmup Mode Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Morning Warmup Mode Off Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Morning Warmup Mode On Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Morning Warmup Mode Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Motion Sensor Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Natural Gas Flow',
        value:  'Cubic Feet Per Minute (Cfm)',
        unitId: '13a96208-b342-46fe-b293-5c5395768b01'
    },
    { 
        id:     'Natural Gas Flow Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Natural Gas Usage',
        value:  'Cubic Feet Per Minute (Cfm)',
        unitId: '13a96208-b342-46fe-b293-5c5395768b01'
    },
    { 
        id:     'Night Purge Mode Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Night Purge Mode Off Setpoint',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Night Purge Mode On Setpoint',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Night Purge Mode Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Nitrogen Dioxide Sensor',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Nitrogen Dioxide Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Occupancy Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Occupancy Command Enum',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Occupancy Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Occupancy Status Enum',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Occupancy Text',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Occupied Air Changes Setpoint',
        value:  'Air Changes Per Hour (ACH)',
        unitId: '43badf12-29ea-411e-b119-270ae9ca28f7'
    },
    { 
        id:     'Oil Level',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Oil Pressure',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Oil Pressure Deviation',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Oil Pressure High Limit',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Oil Pressure Low Limit',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Oil Pressure Max Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Oil Pressure Min Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Oil Pressure Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Oil Temperature',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Oil Temperature Deviation',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Oil Temperature High Limit',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Oil Temperature Low Limit',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Oil Temperature Max Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Oil Temperature Min Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Oil Temperature Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Open Sensor Fault Alarm',
        value:  'Alarm',
        unitId: null
    },
    { 
        id:     'Operating Room Ready',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Optimal Start Mode Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Optimal Start Mode Off Setpoint',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Optimal Start Mode On Setpoint',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Optimal Start Mode Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Optimal Stop Mode Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Optimal Stop Mode Off Setpoint',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Optimal Stop Mode On Setpoint',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Optimal Stop Mode Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Outside Air CO',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Outside Air CO High Limit',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Outside Air CO2',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Outside Air CO2 High Limit',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Outside Air Damper 1 Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Outside Air Damper 1 Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Outside Air Damper 2 Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Outside Air Damper 2 Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Outside Air Damper 3 Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Outside Air Damper 3 Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Outside Air Damper 4 Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Outside Air Damper 4 Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Outside Air Damper 5 Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Outside Air Damper 5 Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Outside Air Damper 6 Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Outside Air Damper 6 Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Outside Air Damper Open Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Outside Air Damper Position',
        value:  'Percentage (%)',
        unitId: 'bd1f4749-9598-4c27-b879-073e6783a775'
    },
    { 
        id:     'Outside Air Damper Position Command',
        value:  'Percentage (%)',
        unitId: 'bd1f4749-9598-4c27-b879-073e6783a775'
    },
    { 
        id:     'Outside Air Damper Position Max Command',
        value:  'Percentage (%)',
        unitId: 'bd1f4749-9598-4c27-b879-073e6783a775'
    },
    { 
        id:     'Outside Air Damper Position Min Command',
        value:  'Percentage (%)',
        unitId: 'bd1f4749-9598-4c27-b879-073e6783a775'
    },
    { 
        id:     'Outside Air Dewpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Outside Air Dewpoint High Limit',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Outside Air Dewpoint Low Limit',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Outside Air Dewpoint Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Outside Air Enthalpy',
        value:  'Btu Per Pound (BTU/Lb)',
        unitId: 'd9a10744-cdfb-48af-8766-6238d86a8aae'
    },
    { 
        id:     'Outside Air Enthalpy Deviation',
        value:  'Btu Per Pound (BTU/Lb)',
        unitId: 'd9a10744-cdfb-48af-8766-6238d86a8aae'
    },
    { 
        id:     'Outside Air Enthalpy Max Setpoint',
        value:  'Btu Per Pound (BTU/Lb)',
        unitId: 'd9a10744-cdfb-48af-8766-6238d86a8aae'
    },
    { 
        id:     'Outside Air Enthalpy Min Setpoint',
        value:  'Btu Per Pound (BTU/Lb)',
        unitId: 'd9a10744-cdfb-48af-8766-6238d86a8aae'
    },
    { 
        id:     'Outside Air Enthalpy Setpoint',
        value:  'Btu Per Pound (BTU/Lb)',
        unitId: 'd9a10744-cdfb-48af-8766-6238d86a8aae'
    },
    { 
        id:     'Outside Air Flow',
        value:  'Cubic Feet Per Minute (Cfm)',
        unitId: '13a96208-b342-46fe-b293-5c5395768b01'
    },
    { 
        id:     'Outside Air Flow Deviation',
        value:  'Cubic Feet Per Minute (Cfm)',
        unitId: '13a96208-b342-46fe-b293-5c5395768b01'
    },
    { 
        id:     'Outside Air Flow Max Setpoint',
        value:  'Cubic Feet Per Minute (Cfm)',
        unitId: '13a96208-b342-46fe-b293-5c5395768b01'
    },
    { 
        id:     'Outside Air Flow Min Setpoint',
        value:  'Cubic Feet Per Minute (Cfm)',
        unitId: '13a96208-b342-46fe-b293-5c5395768b01'
    },
    { 
        id:     'Outside Air Flow Setpoint',
        value:  'Cubic Feet Per Minute (Cfm)',
        unitId: '13a96208-b342-46fe-b293-5c5395768b01'
    },
    { 
        id:     'Outside Air Flow Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Outside Air Fraction',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Outside Air Methane',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Outside Air Methane High Limit',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Outside Air O2',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Outside Air PM2.5',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Outside Air PM2.5 High Limit',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Outside Air Pressure',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Outside Air Pressure High Limit',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Outside Air Pressure Low Limit',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Outside Air Relative Humidity',
        value:  'Percent Relative Humidity (%RH)',
        unitId: '219d3f18-210d-448f-9bd8-814a496f6f94'
    },
    { 
        id:     'Outside Air Relative Humidity High Limit',
        value:  'Percent Relative Humidity (%RH)',
        unitId: '219d3f18-210d-448f-9bd8-814a496f6f94'
    },
    { 
        id:     'Outside Air Relative Humidity Low Limit',
        value:  'Percent Relative Humidity (%RH)',
        unitId: '219d3f18-210d-448f-9bd8-814a496f6f94'
    },
    { 
        id:     'Outside Air Temperature',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Outside Air Temperature High Limit',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Outside Air Temperature Low Limit',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Outside Air Temperature Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Outside Air TVOC',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Outside Air TVOC High Limit',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Outside Air Wet Bulb',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Outside Air Wet Bulb High Limit',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Outside Air Wet Bulb Low Limit',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Outside Light Level',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Parallel Fan Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Parallel Fan Current',
        value:  'Ampere (A)',
        unitId: '07515d1e-c260-42d9-81b5-cfd65c66d7cf'
    },
    { 
        id:     'Parallel Fan Electric Usage',
        value:  'Kilowatt Hour (KWh)',
        unitId: 'eb844ee5-8420-4829-b57e-daa8547f5e3c'
    },
    { 
        id:     'Parallel Fan Frequency',
        value:  'Hertz (Hz)',
        unitId: 'e4ef5692-143b-4102-9cd3-b3cc4ce0216b'
    },
    { 
        id:     'Parallel Fan Horsepower',
        value:  'Horsepower (Hp)',
        unitId: 'bb7650f1-d12e-4253-9efb-7b6d3867cda5'
    },
    { 
        id:     'Parallel Fan Power',
        value:  'Kilowatt (KW)',
        unitId: 'f147c894-0c59-41ad-85ec-f26b5a6315cf'
    },
    { 
        id:     'Parallel Fan Power Factor',
        value:  'Unitless ()',
        unitId: 'e9301189-9503-4ef1-aa07-72a14d949688'
    },
    { 
        id:     'Parallel Fan Resistance',
        value:  'Ohm (Î©)',
        unitId: 'd41dc7fc-608c-4048-bcc4-42a9afe8ec61'
    },
    { 
        id:     'Parallel Fan RPM',
        value:  'Revolutions Per Minute (Rpm)',
        unitId: '20ede1b5-acbc-40fa-b2f5-f9864c750533'
    },
    { 
        id:     'Parallel Fan Runtime',
        value:  'Second (Sec)',
        unitId: 'b0f5c0ad-8643-489b-90f7-f0a75fc4fe76'
    },
    { 
        id:     'Parallel Fan Speed',
        value:  'Revolutions Per Minute (Rpm)',
        unitId: '20ede1b5-acbc-40fa-b2f5-f9864c750533'
    },
    { 
        id:     'Parallel Fan Speed Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Parallel Fan Speed Max Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Parallel Fan Speed Min Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Parallel Fan Starts',
        value:  'Unitless ()',
        unitId: 'e9301189-9503-4ef1-aa07-72a14d949688'
    },
    { 
        id:     'Parallel Fan Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Parallel Fan Voltage',
        value:  'Volt (V)',
        unitId: 'ceffcac4-ab75-4906-9207-7b4693b304ef'
    },
    { 
        id:     'Phase Monitor Alarm Status',
        value:  'Alarm',
        unitId: null
    },
    { 
        id:     'Phase Monitor Alarm Status Enum',
        value:  'Alarm',
        unitId: null
    },
    { 
        id:     'Phase Monitor Alarm Text',
        value:  'Alarm',
        unitId: null
    },
    { 
        id:     'Power',
        value:  'Kilowatt (KW)',
        unitId: 'f147c894-0c59-41ad-85ec-f26b5a6315cf'
    },
    { 
        id:     'Power Factor',
        value:  'Unitless ()',
        unitId: 'e9301189-9503-4ef1-aa07-72a14d949688'
    },
    { 
        id:     'Precooling Air Temperature',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Preheat Air CO',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Preheat Air CO Deviation',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Preheat Air CO High Limit',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Preheat Air CO Max Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Preheat Air CO Min Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Preheat Air CO Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Preheat Air CO2',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Preheat Air CO2 Deviation',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Preheat Air CO2 High Limit',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Preheat Air CO2 Max Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Preheat Air CO2 Min Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Preheat Air CO2 Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Preheat Air Dewpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Preheat Air Dewpoint High Limit',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Preheat Air Dewpoint Low Limit',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Preheat Air Dewpoint Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Preheat Air Enthalpy',
        value:  'Btu Per Pound (BTU/Lb)',
        unitId: 'd9a10744-cdfb-48af-8766-6238d86a8aae'
    },
    { 
        id:     'Preheat Air Enthalpy Deviation',
        value:  'Btu Per Pound (BTU/Lb)',
        unitId: 'd9a10744-cdfb-48af-8766-6238d86a8aae'
    },
    { 
        id:     'Preheat Air Enthalpy Max Setpoint',
        value:  'Btu Per Pound (BTU/Lb)',
        unitId: 'd9a10744-cdfb-48af-8766-6238d86a8aae'
    },
    { 
        id:     'Preheat Air Enthalpy Min Setpoint',
        value:  'Btu Per Pound (BTU/Lb)',
        unitId: 'd9a10744-cdfb-48af-8766-6238d86a8aae'
    },
    { 
        id:     'Preheat Air Enthalpy Setpoint',
        value:  'Btu Per Pound (BTU/Lb)',
        unitId: 'd9a10744-cdfb-48af-8766-6238d86a8aae'
    },
    { 
        id:     'Preheat Air Flow',
        value:  'Cubic Feet Per Minute (Cfm)',
        unitId: '13a96208-b342-46fe-b293-5c5395768b01'
    },
    { 
        id:     'Preheat Air Flow Deviation',
        value:  'Cubic Feet Per Minute (Cfm)',
        unitId: '13a96208-b342-46fe-b293-5c5395768b01'
    },
    { 
        id:     'Preheat Air Flow Max Setpoint',
        value:  'Cubic Feet Per Minute (Cfm)',
        unitId: '13a96208-b342-46fe-b293-5c5395768b01'
    },
    { 
        id:     'Preheat Air Flow Min Setpoint',
        value:  'Cubic Feet Per Minute (Cfm)',
        unitId: '13a96208-b342-46fe-b293-5c5395768b01'
    },
    { 
        id:     'Preheat Air Flow Setpoint',
        value:  'Cubic Feet Per Minute (Cfm)',
        unitId: '13a96208-b342-46fe-b293-5c5395768b01'
    },
    { 
        id:     'Preheat Air Flow Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Preheat Air Methane',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Preheat Air Methane Deviation',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Preheat Air Methane High Limit',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Preheat Air Methane Max Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Preheat Air Methane Min Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Preheat Air Methane Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Preheat Air O2',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Preheat Air O2 Deviation',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Preheat Air O2 Max Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Preheat Air O2 Min Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Preheat Air O2 Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Preheat Air PM2.5',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Preheat Air PM2.5 Deviation',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Preheat Air PM2.5 High Limit',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Preheat Air PM2.5 Max Setpoint',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Preheat Air PM2.5 Min Setpoint',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Preheat Air PM2.5 Setpoint',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Preheat Air Pressure',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Preheat Air Pressure Deviation',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Preheat Air Pressure High Limit',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Preheat Air Pressure Low Limit',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Preheat Air Pressure Max Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Preheat Air Pressure Min Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Preheat Air Pressure Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Preheat Air Relative Humidity',
        value:  'Percent Relative Humidity (%RH)',
        unitId: '219d3f18-210d-448f-9bd8-814a496f6f94'
    },
    { 
        id:     'Preheat Air Relative Humidity Deviation',
        value:  'Percent Relative Humidity (%RH)',
        unitId: '219d3f18-210d-448f-9bd8-814a496f6f94'
    },
    { 
        id:     'Preheat Air Relative Humidity High Limit',
        value:  'Percent Relative Humidity (%RH)',
        unitId: '219d3f18-210d-448f-9bd8-814a496f6f94'
    },
    { 
        id:     'Preheat Air Relative Humidity Low Limit',
        value:  'Percent Relative Humidity (%RH)',
        unitId: '219d3f18-210d-448f-9bd8-814a496f6f94'
    },
    { 
        id:     'Preheat Air Relative Humidity Max Setpoint',
        value:  'Percent Relative Humidity (%RH)',
        unitId: '219d3f18-210d-448f-9bd8-814a496f6f94'
    },
    { 
        id:     'Preheat Air Relative Humidity Min Setpoint',
        value:  'Percent Relative Humidity (%RH)',
        unitId: '219d3f18-210d-448f-9bd8-814a496f6f94'
    },
    { 
        id:     'Preheat Air Relative Humidity Setpoint',
        value:  'Percent Relative Humidity (%RH)',
        unitId: '219d3f18-210d-448f-9bd8-814a496f6f94'
    },
    { 
        id:     'Preheat Air Temperature',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Preheat Air Temperature Deviation',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Preheat Air Temperature High Limit',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Preheat Air Temperature Low Limit',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Preheat Air Temperature Max Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Preheat Air Temperature Min Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Preheat Air Temperature Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Preheat Air TVOC',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Preheat Air TVOC Deviation',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Preheat Air TVOC High Limit',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Preheat Air TVOC Max Setpoint',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Preheat Air TVOC Min Setpoint',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Preheat Air TVOC Setpoint',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Preheat Air Wet Bulb',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Preheat Air Wet Bulb High Limit',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Preheat Air Wet Bulb Low Limit',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Preheat Stage Capacity',
        value:  'Percentage (%)',
        unitId: 'bd1f4749-9598-4c27-b879-073e6783a775'
    },
    { 
        id:     'Preheat Stage Capacity Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Preheat Stage Capacity Max Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Preheat Stage Capacity Min Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Preheat Stage Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Preheat Stage Current',
        value:  'Ampere (A)',
        unitId: '07515d1e-c260-42d9-81b5-cfd65c66d7cf'
    },
    { 
        id:     'Preheat Stage Electric Usage',
        value:  'Kilowatt Hour (KWh)',
        unitId: 'eb844ee5-8420-4829-b57e-daa8547f5e3c'
    },
    { 
        id:     'Preheat Stage Frequency',
        value:  'Hertz (Hz)',
        unitId: 'e4ef5692-143b-4102-9cd3-b3cc4ce0216b'
    },
    { 
        id:     'Preheat Stage Horsepower',
        value:  'Horsepower (Hp)',
        unitId: 'bb7650f1-d12e-4253-9efb-7b6d3867cda5'
    },
    { 
        id:     'Preheat Stage Power',
        value:  'Kilowatt (KW)',
        unitId: 'f147c894-0c59-41ad-85ec-f26b5a6315cf'
    },
    { 
        id:     'Preheat Stage Power Factor',
        value:  'Unitless ()',
        unitId: 'e9301189-9503-4ef1-aa07-72a14d949688'
    },
    { 
        id:     'Preheat Stage Resistance',
        value:  'Ohm (Î©)',
        unitId: 'd41dc7fc-608c-4048-bcc4-42a9afe8ec61'
    },
    { 
        id:     'Preheat Stage Runtime',
        value:  'Second (Sec)',
        unitId: 'b0f5c0ad-8643-489b-90f7-f0a75fc4fe76'
    },
    { 
        id:     'Preheat Stage Starts',
        value:  'Unitless ()',
        unitId: 'e9301189-9503-4ef1-aa07-72a14d949688'
    },
    { 
        id:     'Preheat Stage Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Preheat Stage Voltage',
        value:  'Volt (V)',
        unitId: 'ceffcac4-ab75-4906-9207-7b4693b304ef'
    },
    { 
        id:     'Preheat Valve Open Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Preheat Valve Open Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Preheat Valve Position',
        value:  'Percentage (%)',
        unitId: 'bd1f4749-9598-4c27-b879-073e6783a775'
    },
    { 
        id:     'Preheat Valve Position Command',
        value:  'Percentage (%)',
        unitId: 'bd1f4749-9598-4c27-b879-073e6783a775'
    },
    { 
        id:     'Preheat Valve Position Max Command',
        value:  'Percentage (%)',
        unitId: 'bd1f4749-9598-4c27-b879-073e6783a775'
    },
    { 
        id:     'Preheat Valve Position Min Command',
        value:  'Percentage (%)',
        unitId: 'bd1f4749-9598-4c27-b879-073e6783a775'
    },
    { 
        id:     'Primary Air CO',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Primary Air CO High Limit',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Primary Air CO2',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Primary Air CO2 High Limit',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Primary Air Dewpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Primary Air Dewpoint High Limit',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Primary Air Dewpoint Low Limit',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Primary Air Enthalpy',
        value:  'Btu Per Pound (BTU/Lb)',
        unitId: 'd9a10744-cdfb-48af-8766-6238d86a8aae'
    },
    { 
        id:     'Primary Air Flow',
        value:  'Cubic Feet Per Minute (Cfm)',
        unitId: '13a96208-b342-46fe-b293-5c5395768b01'
    },
    { 
        id:     'Primary Air Flow Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Primary Air Methane',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Primary Air Methane High Limit',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Primary Air O2',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Primary Air PM2.5',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Primary Air PM2.5 High Limit',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Primary Air Pressure',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Primary Air Pressure High Limit',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Primary Air Pressure Low Limit',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Primary Air Relative Humidity',
        value:  'Percent Relative Humidity (%RH)',
        unitId: '219d3f18-210d-448f-9bd8-814a496f6f94'
    },
    { 
        id:     'Primary Air Relative Humidity High Limit',
        value:  'Percent Relative Humidity (%RH)',
        unitId: '219d3f18-210d-448f-9bd8-814a496f6f94'
    },
    { 
        id:     'Primary Air Relative Humidity Low Limit',
        value:  'Percent Relative Humidity (%RH)',
        unitId: '219d3f18-210d-448f-9bd8-814a496f6f94'
    },
    { 
        id:     'Primary Air Temperature',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Primary Air Temperature High Limit',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Primary Air Temperature Low Limit',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Primary Air TVOC',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Primary Air TVOC High Limit',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Primary Air Wet Bulb',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Primary Air Wet Bulb High Limit',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Primary Air Wet Bulb Low Limit',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Primary Chilled Water Pump Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Primary Chilled Water Pump Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Primary Differential Water Pressure',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Primary Differential Water Pressure Deviation',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Primary Differential Water Pressure High Limit',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Primary Differential Water Pressure Low Limit',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Primary Differential Water Pressure Max Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Primary Differential Water Pressure Min Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Primary Differential Water Pressure Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Primary Differential Water Temperature',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Primary Differential Water Temperature High Limit',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Primary Differential Water Temperature Low Limit',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Primary Return Water Flow',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Primary Return Water Flow Deviation',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Primary Return Water Flow Max Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Primary Return Water Flow Min Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Primary Return Water Flow Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Primary Return Water Flow Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Primary Return Water Pressure',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Primary Return Water Pressure Deviation',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Primary Return Water Pressure High Limit',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Primary Return Water Pressure Low Limit',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Primary Return Water Pressure Max Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Primary Return Water Pressure Min Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Primary Return Water Pressure Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Primary Return Water Temperature',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Primary Return Water Temperature Cooling Deadband',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Primary Return Water Temperature Cooling Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Primary Return Water Temperature Deadband',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Primary Return Water Temperature Deviation',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Primary Return Water Temperature Heating Deadband',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Primary Return Water Temperature Heating Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Primary Return Water Temperature High Limit',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Primary Return Water Temperature Low Limit',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Primary Return Water Temperature Max Cooling Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Primary Return Water Temperature Max Heating Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Primary Return Water Temperature Max Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Primary Return Water Temperature Min Cooling Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Primary Return Water Temperature Min Heating Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Primary Return Water Temperature Min Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Primary Return Water Temperature Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Primary Return Water Total Dissolved Solids',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Primary Return Water Total Dissolved Solids Deviation',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Primary Return Water Total Dissolved Solids High Limit',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Primary Return Water Total Dissolved Solids Max Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Primary Return Water Total Dissolved Solids Min Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Primary Return Water Total Dissolved Solids Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Primary Return Water Usage',
        value:  'Gallons Per Minute (Gal/Min)',
        unitId: '74497096-2815-426b-a708-c7b8e3e169b7'
    },
    { 
        id:     'Primary Supply Valve Open Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Primary Supply Valve Open Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Primary Supply Valve Position',
        value:  'Percentage (%)',
        unitId: 'bd1f4749-9598-4c27-b879-073e6783a775'
    },
    { 
        id:     'Primary Supply Valve Position Command',
        value:  'Percentage (%)',
        unitId: 'bd1f4749-9598-4c27-b879-073e6783a775'
    },
    { 
        id:     'Primary Supply Valve Position Max Command',
        value:  'Percentage (%)',
        unitId: 'bd1f4749-9598-4c27-b879-073e6783a775'
    },
    { 
        id:     'Primary Supply Valve Position Min Command',
        value:  'Percentage (%)',
        unitId: 'bd1f4749-9598-4c27-b879-073e6783a775'
    },
    { 
        id:     'Primary Supply Water Flow',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Primary Supply Water Flow Deviation',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Primary Supply Water Flow Max Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Primary Supply Water Flow Min Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Primary Supply Water Flow Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Primary Supply Water Flow Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Primary Supply Water Pressure',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Primary Supply Water Pressure Deviation',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Primary Supply Water Pressure High Limit',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Primary Supply Water Pressure Low Limit',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Primary Supply Water Pressure Max Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Primary Supply Water Pressure Min Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Primary Supply Water Pressure Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Primary Supply Water Temperature',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Primary Supply Water Temperature Cooling Deadband',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Primary Supply Water Temperature Cooling Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Primary Supply Water Temperature Deadband',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Primary Supply Water Temperature Deviation',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Primary Supply Water Temperature Heating Deadband',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Primary Supply Water Temperature Heating Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Primary Supply Water Temperature High Limit',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Primary Supply Water Temperature Low Limit',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Primary Supply Water Temperature Max Cooling Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Primary Supply Water Temperature Max Heating Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Primary Supply Water Temperature Max Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Primary Supply Water Temperature Min Cooling Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Primary Supply Water Temperature Min Heating Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Primary Supply Water Temperature Min Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Primary Supply Water Temperature Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Primary Supply Water Total Dissolved Solids',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Primary Supply Water Total Dissolved Solids Deviation',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Primary Supply Water Total Dissolved Solids High Limit',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Primary Supply Water Total Dissolved Solids Max Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Primary Supply Water Total Dissolved Solids Min Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Primary Supply Water Total Dissolved Solids Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Primary Supply Water Usage',
        value:  'Gallons Per Minute (Gal/Min)',
        unitId: '74497096-2815-426b-a708-c7b8e3e169b7'
    },
    { 
        id:     'Primary Water Pump 1 Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Primary Water Pump 1 Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Primary Water Pump 2 Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Primary Water Pump 2 Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Product Temperature',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Product Temperature Cooling Deadband',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Product Temperature Cooling Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Product Temperature Deadband',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Product Temperature Deviation',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Product Temperature Heating Deadband',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Product Temperature Heating Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Product Temperature High Limit',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Product Temperature Low Limit',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Product Temperature Max Cooling Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Product Temperature Max Heating Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Product Temperature Max Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Product Temperature Min Cooling Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Product Temperature Min Heating Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Product Temperature Min Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Product Temperature Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Recirculation Pump Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Recirculation Pump Current',
        value:  'Ampere (A)',
        unitId: '07515d1e-c260-42d9-81b5-cfd65c66d7cf'
    },
    { 
        id:     'Recirculation Pump Electric Usage',
        value:  'Kilowatt Hour (KWh)',
        unitId: 'eb844ee5-8420-4829-b57e-daa8547f5e3c'
    },
    { 
        id:     'Recirculation Pump Frequency',
        value:  'Hertz (Hz)',
        unitId: 'e4ef5692-143b-4102-9cd3-b3cc4ce0216b'
    },
    { 
        id:     'Recirculation Pump Horsepower',
        value:  'Horsepower (Hp)',
        unitId: 'bb7650f1-d12e-4253-9efb-7b6d3867cda5'
    },
    { 
        id:     'Recirculation Pump Power',
        value:  'Kilowatt (KW)',
        unitId: 'f147c894-0c59-41ad-85ec-f26b5a6315cf'
    },
    { 
        id:     'Recirculation Pump Power Factor',
        value:  'Unitless ()',
        unitId: 'e9301189-9503-4ef1-aa07-72a14d949688'
    },
    { 
        id:     'Recirculation Pump Resistance',
        value:  'Ohm (Î©)',
        unitId: 'd41dc7fc-608c-4048-bcc4-42a9afe8ec61'
    },
    { 
        id:     'Recirculation Pump RPM',
        value:  'Revolutions Per Minute (Rpm)',
        unitId: '20ede1b5-acbc-40fa-b2f5-f9864c750533'
    },
    { 
        id:     'Recirculation Pump Runtime',
        value:  'Second (Sec)',
        unitId: 'b0f5c0ad-8643-489b-90f7-f0a75fc4fe76'
    },
    { 
        id:     'Recirculation Pump Speed',
        value:  'Revolutions Per Minute (Rpm)',
        unitId: '20ede1b5-acbc-40fa-b2f5-f9864c750533'
    },
    { 
        id:     'Recirculation Pump Speed Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Recirculation Pump Speed Max Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Recirculation Pump Speed Min Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Recirculation Pump Starts',
        value:  'Unitless ()',
        unitId: 'e9301189-9503-4ef1-aa07-72a14d949688'
    },
    { 
        id:     'Recirculation Pump Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Recirculation Pump Voltage',
        value:  'Volt (V)',
        unitId: 'ceffcac4-ab75-4906-9207-7b4693b304ef'
    },
    { 
        id:     'Resistance',
        value:  'Ohm (Î©)',
        unitId: 'd41dc7fc-608c-4048-bcc4-42a9afe8ec61'
    },
    { 
        id:     'Return Air CO',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Return Air CO Deviation',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Return Air CO High Limit',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Return Air CO Max Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Return Air CO Min Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Return Air CO Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Return Air CO2',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Return Air CO2 Deviation',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Return Air CO2 High Limit',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Return Air CO2 Max Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Return Air CO2 Min Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Return Air CO2 Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Return Air Dewpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Return Air Dewpoint High Limit',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Return Air Dewpoint Low Limit',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Return Air Dewpoint Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Return Air Enthalpy',
        value:  'Btu Per Pound (BTU/Lb)',
        unitId: 'd9a10744-cdfb-48af-8766-6238d86a8aae'
    },
    { 
        id:     'Return Air Enthalpy Deviation',
        value:  'Btu Per Pound (BTU/Lb)',
        unitId: 'd9a10744-cdfb-48af-8766-6238d86a8aae'
    },
    { 
        id:     'Return Air Enthalpy Max Setpoint',
        value:  'Btu Per Pound (BTU/Lb)',
        unitId: 'd9a10744-cdfb-48af-8766-6238d86a8aae'
    },
    { 
        id:     'Return Air Enthalpy Min Setpoint',
        value:  'Btu Per Pound (BTU/Lb)',
        unitId: 'd9a10744-cdfb-48af-8766-6238d86a8aae'
    },
    { 
        id:     'Return Air Enthalpy Setpoint',
        value:  'Btu Per Pound (BTU/Lb)',
        unitId: 'd9a10744-cdfb-48af-8766-6238d86a8aae'
    },
    { 
        id:     'Return Air Flow',
        value:  'Cubic Feet Per Minute (Cfm)',
        unitId: '13a96208-b342-46fe-b293-5c5395768b01'
    },
    { 
        id:     'Return Air Flow Deviation',
        value:  'Cubic Feet Per Minute (Cfm)',
        unitId: '13a96208-b342-46fe-b293-5c5395768b01'
    },
    { 
        id:     'Return Air Flow Max Setpoint',
        value:  'Cubic Feet Per Minute (Cfm)',
        unitId: '13a96208-b342-46fe-b293-5c5395768b01'
    },
    { 
        id:     'Return Air Flow Min Setpoint',
        value:  'Cubic Feet Per Minute (Cfm)',
        unitId: '13a96208-b342-46fe-b293-5c5395768b01'
    },
    { 
        id:     'Return Air Flow Setpoint',
        value:  'Cubic Feet Per Minute (Cfm)',
        unitId: '13a96208-b342-46fe-b293-5c5395768b01'
    },
    { 
        id:     'Return Air Flow Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Return Air Methane',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Return Air Methane Deviation',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Return Air Methane High Limit',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Return Air Methane Max Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Return Air Methane Min Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Return Air Methane Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Return Air O2',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Return Air O2 Deviation',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Return Air O2 Max Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Return Air O2 Min Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Return Air O2 Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Return Air PM2.5',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Return Air PM2.5 Deviation',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Return Air PM2.5 High Limit',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Return Air PM2.5 Max Setpoint',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Return Air PM2.5 Min Setpoint',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Return Air PM2.5 Setpoint',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Return Air Pressure',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Return Air Pressure Deviation',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Return Air Pressure High Limit',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Return Air Pressure Low Limit',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Return Air Pressure Max Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Return Air Pressure Min Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Return Air Pressure Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Return Air Relative Humidity',
        value:  'Percent Relative Humidity (%RH)',
        unitId: '219d3f18-210d-448f-9bd8-814a496f6f94'
    },
    { 
        id:     'Return Air Relative Humidity Deviation',
        value:  'Percent Relative Humidity (%RH)',
        unitId: '219d3f18-210d-448f-9bd8-814a496f6f94'
    },
    { 
        id:     'Return Air Relative Humidity High Limit',
        value:  'Percent Relative Humidity (%RH)',
        unitId: '219d3f18-210d-448f-9bd8-814a496f6f94'
    },
    { 
        id:     'Return Air Relative Humidity Low Limit',
        value:  'Percent Relative Humidity (%RH)',
        unitId: '219d3f18-210d-448f-9bd8-814a496f6f94'
    },
    { 
        id:     'Return Air Relative Humidity Max Setpoint',
        value:  'Percent Relative Humidity (%RH)',
        unitId: '219d3f18-210d-448f-9bd8-814a496f6f94'
    },
    { 
        id:     'Return Air Relative Humidity Min Setpoint',
        value:  'Percent Relative Humidity (%RH)',
        unitId: '219d3f18-210d-448f-9bd8-814a496f6f94'
    },
    { 
        id:     'Return Air Relative Humidity Setpoint',
        value:  'Percent Relative Humidity (%RH)',
        unitId: '219d3f18-210d-448f-9bd8-814a496f6f94'
    },
    { 
        id:     'Return Air Temperature',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Return Air Temperature Cooling Deadband',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Return Air Temperature Cooling Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Return Air Temperature Deadband',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Return Air Temperature Deviation',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Return Air Temperature Heating Deadband',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Return Air Temperature Heating Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Return Air Temperature High Limit',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Return Air Temperature Low Limit',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Return Air Temperature Max Cooling Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Return Air Temperature Max Heating Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Return Air Temperature Max Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Return Air Temperature Min Cooling Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Return Air Temperature Min Heating Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Return Air Temperature Min Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Return Air Temperature Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Return Air TVOC',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Return Air TVOC Deviation',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Return Air TVOC High Limit',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Return Air TVOC Max Setpoint',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Return Air TVOC Min Setpoint',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Return Air TVOC Setpoint',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Return Air Wet Bulb',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Return Air Wet Bulb High Limit',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Return Air Wet Bulb Low Limit',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Return Damper Open Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Return Damper Open Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Return Damper Position',
        value:  'Percentage (%)',
        unitId: 'bd1f4749-9598-4c27-b879-073e6783a775'
    },
    { 
        id:     'Return Damper Position Command',
        value:  'Percentage (%)',
        unitId: 'bd1f4749-9598-4c27-b879-073e6783a775'
    },
    { 
        id:     'Return Damper Position Max Command',
        value:  'Percentage (%)',
        unitId: 'bd1f4749-9598-4c27-b879-073e6783a775'
    },
    { 
        id:     'Return Damper Position Min Command',
        value:  'Percentage (%)',
        unitId: 'bd1f4749-9598-4c27-b879-073e6783a775'
    },
    { 
        id:     'Return Fan 1 Alarm',
        value:  'Alarm',
        unitId: null
    },
    { 
        id:     'Return Fan 2 Alarm',
        value:  'Alarm',
        unitId: null
    },
    { 
        id:     'Return Fan Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Return Fan Current',
        value:  'Ampere (A)',
        unitId: '07515d1e-c260-42d9-81b5-cfd65c66d7cf'
    },
    { 
        id:     'Return Fan Electric Usage',
        value:  'Kilowatt Hour (KWh)',
        unitId: 'eb844ee5-8420-4829-b57e-daa8547f5e3c'
    },
    { 
        id:     'Return Fan Frequency',
        value:  'Hertz (Hz)',
        unitId: 'e4ef5692-143b-4102-9cd3-b3cc4ce0216b'
    },
    { 
        id:     'Return Fan Horsepower',
        value:  'Horsepower (Hp)',
        unitId: 'bb7650f1-d12e-4253-9efb-7b6d3867cda5'
    },
    { 
        id:     'Return Fan Power',
        value:  'Kilowatt (KW)',
        unitId: 'f147c894-0c59-41ad-85ec-f26b5a6315cf'
    },
    { 
        id:     'Return Fan Power Factor',
        value:  'Unitless ()',
        unitId: 'e9301189-9503-4ef1-aa07-72a14d949688'
    },
    { 
        id:     'Return Fan Resistance',
        value:  'Ohm (Î©)',
        unitId: 'd41dc7fc-608c-4048-bcc4-42a9afe8ec61'
    },
    { 
        id:     'Return Fan RPM',
        value:  'Revolutions Per Minute (Rpm)',
        unitId: '20ede1b5-acbc-40fa-b2f5-f9864c750533'
    },
    { 
        id:     'Return Fan Runtime',
        value:  'Second (Sec)',
        unitId: 'b0f5c0ad-8643-489b-90f7-f0a75fc4fe76'
    },
    { 
        id:     'Return Fan Speed',
        value:  'Revolutions Per Minute (Rpm)',
        unitId: '20ede1b5-acbc-40fa-b2f5-f9864c750533'
    },
    { 
        id:     'Return Fan Speed Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Return Fan Speed Max Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Return Fan Speed Min Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Return Fan Starts',
        value:  'Unitless ()',
        unitId: 'e9301189-9503-4ef1-aa07-72a14d949688'
    },
    { 
        id:     'Return Fan Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Return Fan Voltage',
        value:  'Volt (V)',
        unitId: 'ceffcac4-ab75-4906-9207-7b4693b304ef'
    },
    { 
        id:     'Return Steam Pressure',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Return Steam Pressure Deviation',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Return Steam Pressure High Limit',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Return Steam Pressure Low Limit',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Return Steam Pressure Max Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Return Steam Pressure Min Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Return Steam Pressure Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Return Water Flow',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Return Water Flow Deviation',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Return Water Flow Max Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Return Water Flow Min Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Return Water Flow Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Return Water Flow Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Return Water Pressure',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Return Water Pressure Deviation',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Return Water Pressure High Limit',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Return Water Pressure Low Limit',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Return Water Pressure Max Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Return Water Pressure Min Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Return Water Pressure Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Return Water Temperature',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Return Water Temperature Cooling Deadband',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Return Water Temperature Cooling Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Return Water Temperature Deadband',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Return Water Temperature Deviation',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Return Water Temperature Heating Deadband',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Return Water Temperature Heating Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Return Water Temperature High Limit',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Return Water Temperature Low Limit',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Return Water Temperature Max Cooling Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Return Water Temperature Max Heating Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Return Water Temperature Max Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Return Water Temperature Min Cooling Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Return Water Temperature Min Heating Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Return Water Temperature Min Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Return Water Temperature Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Return Water Total Dissolved Solids',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Return Water Total Dissolved Solids Deviation',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Return Water Total Dissolved Solids High Limit',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Return Water Total Dissolved Solids Max Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Return Water Total Dissolved Solids Min Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Return Water Total Dissolved Solids Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Return Water Usage',
        value:  'Gallons Per Minute (Gal/Min)',
        unitId: '74497096-2815-426b-a708-c7b8e3e169b7'
    },
    { 
        id:     'Reversing Valve Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Reversing Valve Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'RPM',
        value:  'Revolutions Per Minute (Rpm)',
        unitId: '20ede1b5-acbc-40fa-b2f5-f9864c750533'
    },
    { 
        id:     'Runtime',
        value:  'Second (Sec)',
        unitId: 'b0f5c0ad-8643-489b-90f7-f0a75fc4fe76'
    },
    { 
        id:     'Safety Switch Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Saturated Refrigerant Pressure',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Saturated Refrigerant Pressure Deviation',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Saturated Refrigerant Pressure High Limit',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Saturated Refrigerant Pressure Low Limit',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Saturated Refrigerant Pressure Max Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Saturated Refrigerant Pressure Min Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Saturated Refrigerant Pressure Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Saturated Refrigerant Temperature',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Saturated Refrigerant Temperature Deviation',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Saturated Refrigerant Temperature High Limit',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Saturated Refrigerant Temperature Low Limit',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Saturated Refrigerant Temperature Max Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Saturated Refrigerant Temperature Min Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Saturated Refrigerant Temperature Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Scheduled Occupancy Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Scheduled Occupancy Command Enum',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Scheduled Occupancy Text',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Secondary Chilled Water Pump Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Secondary Chilled Water Pump Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Secondary Differential Water Pressure',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Secondary Differential Water Pressure Deviation',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Secondary Differential Water Pressure High Limit',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Secondary Differential Water Pressure Low Limit',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Secondary Differential Water Pressure Max Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Secondary Differential Water Pressure Min Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Secondary Differential Water Pressure Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Secondary Differential Water Temperature',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Secondary Differential Water Temperature High Limit',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Secondary Differential Water Temperature Low Limit',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Secondary Return Water Flow',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Secondary Return Water Flow Deviation',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Secondary Return Water Flow Max Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Secondary Return Water Flow Min Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Secondary Return Water Flow Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Secondary Return Water Flow Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Secondary Return Water Pressure',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Secondary Return Water Pressure Deviation',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Secondary Return Water Pressure High Limit',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Secondary Return Water Pressure Low Limit',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Secondary Return Water Pressure Max Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Secondary Return Water Pressure Min Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Secondary Return Water Pressure Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Secondary Return Water Temperature',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Secondary Return Water Temperature Cooling Deadband',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Secondary Return Water Temperature Cooling Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Secondary Return Water Temperature Deadband',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Secondary Return Water Temperature Deviation',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Secondary Return Water Temperature Heating Deadband',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Secondary Return Water Temperature Heating Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Secondary Return Water Temperature High Limit',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Secondary Return Water Temperature Low Limit',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Secondary Return Water Temperature Max Cooling Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Secondary Return Water Temperature Max Heating Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Secondary Return Water Temperature Max Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Secondary Return Water Temperature Min Cooling Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Secondary Return Water Temperature Min Heating Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Secondary Return Water Temperature Min Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Secondary Return Water Temperature Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Secondary Return Water Total Dissolved Solids',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Secondary Return Water Total Dissolved Solids Deviation',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Secondary Return Water Total Dissolved Solids High Limit',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Secondary Return Water Total Dissolved Solids Max Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Secondary Return Water Total Dissolved Solids Min Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Secondary Return Water Total Dissolved Solids Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Secondary Return Water Usage',
        value:  'Gallons Per Minute (Gal/Min)',
        unitId: '74497096-2815-426b-a708-c7b8e3e169b7'
    },
    { 
        id:     'Secondary Supply Valve Open Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Secondary Supply Valve Open Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Secondary Supply Valve Position',
        value:  'Percentage (%)',
        unitId: 'bd1f4749-9598-4c27-b879-073e6783a775'
    },
    { 
        id:     'Secondary Supply Valve Position Command',
        value:  'Percentage (%)',
        unitId: 'bd1f4749-9598-4c27-b879-073e6783a775'
    },
    { 
        id:     'Secondary Supply Valve Position Max Command',
        value:  'Percentage (%)',
        unitId: 'bd1f4749-9598-4c27-b879-073e6783a775'
    },
    { 
        id:     'Secondary Supply Valve Position Min Command',
        value:  'Percentage (%)',
        unitId: 'bd1f4749-9598-4c27-b879-073e6783a775'
    },
    { 
        id:     'Secondary Supply Water Flow',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Secondary Supply Water Flow Deviation',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Secondary Supply Water Flow Max Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Secondary Supply Water Flow Min Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Secondary Supply Water Flow Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Secondary Supply Water Flow Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Secondary Supply Water Pressure',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Secondary Supply Water Pressure Deviation',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Secondary Supply Water Pressure High Limit',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Secondary Supply Water Pressure Low Limit',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Secondary Supply Water Pressure Max Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Secondary Supply Water Pressure Min Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Secondary Supply Water Pressure Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Secondary Supply Water Temperature',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Secondary Supply Water Temperature Cooling Deadband',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Secondary Supply Water Temperature Cooling Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Secondary Supply Water Temperature Deadband',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Secondary Supply Water Temperature Deviation',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Secondary Supply Water Temperature Heating Deadband',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Secondary Supply Water Temperature Heating Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Secondary Supply Water Temperature High Limit',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Secondary Supply Water Temperature Low Limit',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Secondary Supply Water Temperature Max Cooling Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Secondary Supply Water Temperature Max Heating Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Secondary Supply Water Temperature Max Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Secondary Supply Water Temperature Min Cooling Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Secondary Supply Water Temperature Min Heating Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Secondary Supply Water Temperature Min Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Secondary Supply Water Temperature Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Secondary Supply Water Total Dissolved Solids',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Secondary Supply Water Total Dissolved Solids Deviation',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Secondary Supply Water Total Dissolved Solids High Limit',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Secondary Supply Water Total Dissolved Solids Max Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Secondary Supply Water Total Dissolved Solids Min Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Secondary Supply Water Total Dissolved Solids Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Secondary Supply Water Usage',
        value:  'Gallons Per Minute (Gal/Min)',
        unitId: '74497096-2815-426b-a708-c7b8e3e169b7'
    },
    { 
        id:     'Secondary Water Pump 1 Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Secondary Water Pump 1 Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Secondary Water Pump 2 Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Secondary Water Pump 2 Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:    'Setpoint Adjust Value',
        value: 'Default Display Units'
    },
    { 
        id:     'Site Air Pressure',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Site Air Pressure Deviation',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Site Air Pressure High Limit',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Site Air Pressure Low Limit',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Site Air Pressure Max Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Site Air Pressure Min Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Site Air Pressure Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Site Current',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Site Electric Usage',
        value:  'Ampere (A)',
        unitId: '07515d1e-c260-42d9-81b5-cfd65c66d7cf'
    },
    { 
        id:     'Site Frequency',
        value:  'Kilowatt Hour (KWh)',
        unitId: 'eb844ee5-8420-4829-b57e-daa8547f5e3c'
    },
    { 
        id:     'Site Fuel Usage',
        value:  'Hertz (Hz)',
        unitId: 'e4ef5692-143b-4102-9cd3-b3cc4ce0216b'
    },
    { 
        id:     'Site Natural Gas Flow',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Site Natural Gas Flow Status',
        value:  'Cubic Feet Per Minute (Cfm)',
        unitId: '13a96208-b342-46fe-b293-5c5395768b01'
    },
    { 
        id:     'Site Natural Gas Usage',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Site Power',
        value:  'Cubic Feet Per Minute (Cfm)',
        unitId: '13a96208-b342-46fe-b293-5c5395768b01'
    },
    { 
        id:     'Site Power Factor',
        value:  'Kilowatt (KW)',
        unitId: 'f147c894-0c59-41ad-85ec-f26b5a6315cf'
    },
    { 
        id:     'Site Resistance',
        value:  'Unitless ()',
        unitId: 'e9301189-9503-4ef1-aa07-72a14d949688'
    },
    { 
        id:     'Site Voltage',
        value:  'Ohm (Î©)',
        unitId: 'd41dc7fc-608c-4048-bcc4-42a9afe8ec61'
    },
    { 
        id:     'Site Water Flow',
        value:  'Volt (V)',
        unitId: 'ceffcac4-ab75-4906-9207-7b4693b304ef'
    },
    { 
        id:     'Site Water Flow Status',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Site Water Pressure',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Site Water Pressure High Limit',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Site Water Pressure Low Limit',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Site Water Usage',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Smoke Detector Alarm Status',
        value:  'Gallons Per Minute (Gal/Min)',
        unitId: '74497096-2815-426b-a708-c7b8e3e169b7'
    },
    { 
        id:     'Smoke Detector Alarm Status Enum',
        value:  'Alarm',
        unitId: null
    },
    { 
        id:     'Smoke Detector Alarm Text',
        value:  'Alarm',
        unitId: null
    },
    { 
        id:     'Space Air CO',
        value:  'Alarm',
        unitId: null
    },
    { 
        id:     'Space Air CO Deviation',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Space Air CO High Limit',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Space Air CO Max Occupied Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Space Air CO Max Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Space Air CO Max Standby Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Space Air CO Max Unoccupied Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Space Air CO Min Occupied Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Space Air CO Min Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Space Air CO Min Standby Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Space Air CO Min Unoccupied Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Space Air CO Occupied Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Space Air CO Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Space Air CO Standby Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Space Air CO Unoccupied Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Space Air CO2',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Space Air CO2 Deviation',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Space Air CO2 High Limit',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Space Air CO2 Max Occupied Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Space Air CO2 Max Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Space Air CO2 Max Standby Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Space Air CO2 Max Unoccupied Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Space Air CO2 Min Occupied Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Space Air CO2 Min Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Space Air CO2 Min Standby Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Space Air CO2 Min Unoccupied Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Space Air CO2 Occupied Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Space Air CO2 Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Space Air CO2 Standby Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Space Air CO2 Unoccupied Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Space Air Damper Command',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Space Air Damper Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Space Air Dewpoint',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Space Air Dewpoint High Limit',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Space Air Dewpoint Low Limit',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Space Air Dewpoint Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Space Air Enthalpy',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Space Air Enthalpy Deviation',
        value:  'Btu Per Pound (BTU/Lb)',
        unitId: 'd9a10744-cdfb-48af-8766-6238d86a8aae'
    },
    { 
        id:     'Space Air Enthalpy Max Setpoint',
        value:  'Btu Per Pound (BTU/Lb)',
        unitId: 'd9a10744-cdfb-48af-8766-6238d86a8aae'
    },
    { 
        id:     'Space Air Enthalpy Min Setpoint',
        value:  'Btu Per Pound (BTU/Lb)',
        unitId: 'd9a10744-cdfb-48af-8766-6238d86a8aae'
    },
    { 
        id:     'Space Air Enthalpy Setpoint',
        value:  'Btu Per Pound (BTU/Lb)',
        unitId: 'd9a10744-cdfb-48af-8766-6238d86a8aae'
    },
    { 
        id:     'Space Air Flow',
        value:  'Btu Per Pound (BTU/Lb)',
        unitId: 'd9a10744-cdfb-48af-8766-6238d86a8aae'
    },
    { 
        id:     'Space Air Flow Deviation',
        value:  'Cubic Feet Per Minute (Cfm)',
        unitId: '13a96208-b342-46fe-b293-5c5395768b01'
    },
    { 
        id:     'Space Air Flow Max Occupied Setpoint',
        value:  'Cubic Feet Per Minute (Cfm)',
        unitId: '13a96208-b342-46fe-b293-5c5395768b01'
    },
    { 
        id:     'Space Air Flow Max Setpoint',
        value:  'Cubic Feet Per Minute (Cfm)',
        unitId: '13a96208-b342-46fe-b293-5c5395768b01'
    },
    { 
        id:     'Space Air Flow Max Standby Setpoint',
        value:  'Cubic Feet Per Minute (Cfm)',
        unitId: '13a96208-b342-46fe-b293-5c5395768b01'
    },
    { 
        id:     'Space Air Flow Max Unoccupied Setpoint',
        value:  'Cubic Feet Per Minute (Cfm)',
        unitId: '13a96208-b342-46fe-b293-5c5395768b01'
    },
    { 
        id:     'Space Air Flow Min Occupied Setpoint',
        value:  'Cubic Feet Per Minute (Cfm)',
        unitId: '13a96208-b342-46fe-b293-5c5395768b01'
    },
    { 
        id:     'Space Air Flow Min Setpoint',
        value:  'Cubic Feet Per Minute (Cfm)',
        unitId: '13a96208-b342-46fe-b293-5c5395768b01'
    },
    { 
        id:     'Space Air Flow Min Standby Setpoint',
        value:  'Cubic Feet Per Minute (Cfm)',
        unitId: '13a96208-b342-46fe-b293-5c5395768b01'
    },
    { 
        id:     'Space Air Flow Min Unoccupied Setpoint',
        value:  'Cubic Feet Per Minute (Cfm)',
        unitId: '13a96208-b342-46fe-b293-5c5395768b01'
    },
    { 
        id:     'Space Air Flow Occupied Setpoint',
        value:  'Cubic Feet Per Minute (Cfm)',
        unitId: '13a96208-b342-46fe-b293-5c5395768b01'
    },
    { 
        id:     'Space Air Flow Setpoint',
        value:  'Cubic Feet Per Minute (Cfm)',
        unitId: '13a96208-b342-46fe-b293-5c5395768b01'
    },
    { 
        id:     'Space Air Flow Standby Setpoint',
        value:  'Cubic Feet Per Minute (Cfm)',
        unitId: '13a96208-b342-46fe-b293-5c5395768b01'
    },
    { 
        id:     'Space Air Flow Status',
        value:  'Cubic Feet Per Minute (Cfm)',
        unitId: '13a96208-b342-46fe-b293-5c5395768b01'
    },
    { 
        id:     'Space Air Flow Unoccupied Setpoint',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Space Air Methane',
        value:  'Cubic Feet Per Minute (Cfm)',
        unitId: '13a96208-b342-46fe-b293-5c5395768b01'
    },
    { 
        id:     'Space Air Methane Deviation',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Space Air Methane High Limit',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Space Air Methane Max Occupied Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Space Air Methane Max Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Space Air Methane Max Standby Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Space Air Methane Max Unoccupied Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Space Air Methane Min Occupied Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Space Air Methane Min Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Space Air Methane Min Standby Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Space Air Methane Min Unoccupied Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Space Air Methane Occupied Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Space Air Methane Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Space Air Methane Standby Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Space Air Methane Unoccupied Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Space Air O2',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Space Air O2 Deviation',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Space Air O2 Max Occupied Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Space Air O2 Max Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Space Air O2 Max Standby Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Space Air O2 Max Unoccupied Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Space Air O2 Min Occupied Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Space Air O2 Min Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Space Air O2 Min Standby Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Space Air O2 Min Unoccupied Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Space Air O2 Occupied Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Space Air O2 Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Space Air O2 Standby Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Space Air O2 Unoccupied Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Space Air PM2.5',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Space Air PM2.5 Deviation',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Space Air PM2.5 High Limit',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Space Air PM2.5 Max Occupied Setpoint',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Space Air PM2.5 Max Setpoint',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Space Air PM2.5 Max Standby Setpoint',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Space Air PM2.5 Max Unoccupied Setpoint',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Space Air PM2.5 Min Occupied Setpoint',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Space Air PM2.5 Min Setpoint',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Space Air PM2.5 Min Standby Setpoint',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Space Air PM2.5 Min Unoccupied Setpoint',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Space Air PM2.5 Occupied Setpoint',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Space Air PM2.5 Setpoint',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Space Air PM2.5 Standby Setpoint',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Space Air PM2.5 Unoccupied Setpoint',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Space Air Pressure',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Space Air Pressure Deviation',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Space Air Pressure High Limit',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Space Air Pressure Low Limit',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Space Air Pressure Max Occupied Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Space Air Pressure Max Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Space Air Pressure Max Standby Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Space Air Pressure Max Unoccupied Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Space Air Pressure Min Occupied Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Space Air Pressure Min Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Space Air Pressure Min Standby Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Space Air Pressure Min Unoccupied Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Space Air Pressure Occupied Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Space Air Pressure Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Space Air Pressure Standby Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Space Air Pressure Unoccupied Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Space Air Relative Humidity',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Space Air Relative Humidity Deviation',
        value:  'Percent Relative Humidity (%RH)',
        unitId: '219d3f18-210d-448f-9bd8-814a496f6f94'
    },
    { 
        id:     'Space Air Relative Humidity High Limit',
        value:  'Percent Relative Humidity (%RH)',
        unitId: '219d3f18-210d-448f-9bd8-814a496f6f94'
    },
    { 
        id:     'Space Air Relative Humidity Low Limit',
        value:  'Percent Relative Humidity (%RH)',
        unitId: '219d3f18-210d-448f-9bd8-814a496f6f94'
    },
    { 
        id:     'Space Air Relative Humidity Max Occupied Setpoint',
        value:  'Percent Relative Humidity (%RH)',
        unitId: '219d3f18-210d-448f-9bd8-814a496f6f94'
    },
    { 
        id:     'Space Air Relative Humidity Max Setpoint',
        value:  'Percent Relative Humidity (%RH)',
        unitId: '219d3f18-210d-448f-9bd8-814a496f6f94'
    },
    { 
        id:     'Space Air Relative Humidity Max Standby Setpoint',
        value:  'Percent Relative Humidity (%RH)',
        unitId: '219d3f18-210d-448f-9bd8-814a496f6f94'
    },
    { 
        id:     'Space Air Relative Humidity Max Unoccupied Setpoint',
        value:  'Percent Relative Humidity (%RH)',
        unitId: '219d3f18-210d-448f-9bd8-814a496f6f94'
    },
    { 
        id:     'Space Air Relative Humidity Min Occupied Setpoint',
        value:  'Percent Relative Humidity (%RH)',
        unitId: '219d3f18-210d-448f-9bd8-814a496f6f94'
    },
    { 
        id:     'Space Air Relative Humidity Min Setpoint',
        value:  'Percent Relative Humidity (%RH)',
        unitId: '219d3f18-210d-448f-9bd8-814a496f6f94'
    },
    { 
        id:     'Space Air Relative Humidity Min Standby Setpoint',
        value:  'Percent Relative Humidity (%RH)',
        unitId: '219d3f18-210d-448f-9bd8-814a496f6f94'
    },
    { 
        id:     'Space Air Relative Humidity Min Unoccupied Setpoint',
        value:  'Percent Relative Humidity (%RH)',
        unitId: '219d3f18-210d-448f-9bd8-814a496f6f94'
    },
    { 
        id:     'Space Air Relative Humidity Occupied Setpoint',
        value:  'Percent Relative Humidity (%RH)',
        unitId: '219d3f18-210d-448f-9bd8-814a496f6f94'
    },
    { 
        id:     'Space Air Relative Humidity Setpoint',
        value:  'Percent Relative Humidity (%RH)',
        unitId: '219d3f18-210d-448f-9bd8-814a496f6f94'
    },
    { 
        id:     'Space Air Relative Humidity Standby Setpoint',
        value:  'Percent Relative Humidity (%RH)',
        unitId: '219d3f18-210d-448f-9bd8-814a496f6f94'
    },
    { 
        id:     'Space Air Relative Humidity Unoccupied Setpoint',
        value:  'Percent Relative Humidity (%RH)',
        unitId: '219d3f18-210d-448f-9bd8-814a496f6f94'
    },
    { 
        id:     'Space Air Temperature',
        value:  'Percent Relative Humidity (%RH)',
        unitId: '219d3f18-210d-448f-9bd8-814a496f6f94'
    },
    { 
        id:     'Space Air Temperature Cooling Deadband',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Space Air Temperature Cooling Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Space Air Temperature Deadband',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Space Air Temperature Deviation',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Space Air Temperature Heating Deadband',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Space Air Temperature Heating Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Space Air Temperature High Limit',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Space Air Temperature Low Limit',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Space Air Temperature Max Cooling Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Space Air Temperature Max Heating Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Space Air Temperature Max Occupied Cooling Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Space Air Temperature Max Occupied Heating Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Space Air Temperature Max Occupied Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Space Air Temperature Max Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Space Air Temperature Max Standby Cooling Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Space Air Temperature Max Standby Heating Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Space Air Temperature Max Standby Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Space Air Temperature Max Unoccupied Cooling Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Space Air Temperature Max Unoccupied Heating Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Space Air Temperature Max Unoccupied Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Space Air Temperature Min Cooling Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Space Air Temperature Min Heating Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Space Air Temperature Min Occupied Cooling Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Space Air Temperature Min Occupied Heating Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Space Air Temperature Min Occupied Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Space Air Temperature Min Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Space Air Temperature Min Standby Cooling Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Space Air Temperature Min Standby Heating Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Space Air Temperature Min Standby Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Space Air Temperature Min Unoccupied Cooling Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Space Air Temperature Min Unoccupied Heating Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Space Air Temperature Min Unoccupied Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Space Air Temperature Occupied Cooling Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Space Air Temperature Occupied Heating Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Space Air Temperature Occupied Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Space Air Temperature Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Space Air Temperature Standby Cooling Deadband',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Space Air Temperature Standby Cooling Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Space Air Temperature Standby Deadband',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Space Air Temperature Standby Heating Deadband',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Space Air Temperature Standby Heating Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Space Air Temperature Standby Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Space Air Temperature Unoccupied Cooling Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Space Air Temperature Unoccupied Heating Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Space Air Temperature Unoccupied Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Space Air TVOC',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Space Air TVOC Deviation',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Space Air TVOC High Limit',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Space Air TVOC Max Occupied Setpoint',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Space Air TVOC Max Setpoint',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Space Air TVOC Max Standby Setpoint',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Space Air TVOC Max Unoccupied Setpoint',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Space Air TVOC Min Occupied Setpoint',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Space Air TVOC Min Setpoint',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Space Air TVOC Min Standby Setpoint',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Space Air TVOC Min Unoccupied Setpoint',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Space Air TVOC Occupied Setpoint',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Space Air TVOC Setpoint',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Space Air TVOC Standby Setpoint',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Space Air TVOC Unoccupied Setpoint',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Space Air Wet Bulb',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Space Air Wet Bulb High Limit',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Space Air Wet Bulb Low Limit',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Space Current',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Space Electric Usage',
        value:  'Ampere (A)',
        unitId: '07515d1e-c260-42d9-81b5-cfd65c66d7cf'
    },
    { 
        id:     'Space Fan Command',
        value:  'Kilowatt Hour (KWh)',
        unitId: 'eb844ee5-8420-4829-b57e-daa8547f5e3c'
    },
    { 
        id:     'Space Fan Current',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Space Fan Electric Usage',
        value:  'Ampere (A)',
        unitId: '07515d1e-c260-42d9-81b5-cfd65c66d7cf'
    },
    { 
        id:     'Space Fan Frequency',
        value:  'Kilowatt Hour (KWh)',
        unitId: 'eb844ee5-8420-4829-b57e-daa8547f5e3c'
    },
    { 
        id:     'Space Fan Horsepower',
        value:  'Hertz (Hz)',
        unitId: 'e4ef5692-143b-4102-9cd3-b3cc4ce0216b'
    },
    { 
        id:     'Space Fan Occupied Command',
        value:  'Horsepower (Hp)',
        unitId: 'bb7650f1-d12e-4253-9efb-7b6d3867cda5'
    },
    { 
        id:     'Space Fan Power',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Space Fan Power Factor',
        value:  'Kilowatt (KW)',
        unitId: 'f147c894-0c59-41ad-85ec-f26b5a6315cf'
    },
    { 
        id:     'Space Fan Resistance',
        value:  'Unitless ()',
        unitId: 'e9301189-9503-4ef1-aa07-72a14d949688'
    },
    { 
        id:     'Space Fan RPM',
        value:  'Ohm (Î©)',
        unitId: 'd41dc7fc-608c-4048-bcc4-42a9afe8ec61'
    },
    { 
        id:     'Space Fan Runtime',
        value:  'Revolutions Per Minute (Rpm)',
        unitId: '20ede1b5-acbc-40fa-b2f5-f9864c750533'
    },
    { 
        id:     'Space Fan Speed',
        value:  'Second (Sec)',
        unitId: 'b0f5c0ad-8643-489b-90f7-f0a75fc4fe76'
    },
    { 
        id:     'Space Fan Speed Command',
        value:  'Revolutions Per Minute (Rpm)',
        unitId: '20ede1b5-acbc-40fa-b2f5-f9864c750533'
    },
    { 
        id:     'Space Fan Speed Max Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Space Fan Speed Max Occupied Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Space Fan Speed Max Standby Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Space Fan Speed Max Unoccupied Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Space Fan Speed Min Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Space Fan Speed Min Occupied Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Space Fan Speed Min Standby Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Space Fan Speed Min Unoccupied Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Space Fan Speed Occupied Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Space Fan Speed Standby Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Space Fan Speed Unoccupied Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Space Fan Standby Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Space Fan Starts',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Space Fan Status',
        value:  'Unitless ()',
        unitId: 'e9301189-9503-4ef1-aa07-72a14d949688'
    },
    { 
        id:     'Space Fan Unoccupied Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Space Fan Voltage',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Space Frequency',
        value:  'Volt (V)',
        unitId: 'ceffcac4-ab75-4906-9207-7b4693b304ef'
    },
    { 
        id:     'Space Fuel Usage',
        value:  'Hertz (Hz)',
        unitId: 'e4ef5692-143b-4102-9cd3-b3cc4ce0216b'
    },
    { 
        id:     'Space Light Level',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Space Natural Gas Flow',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Space Natural Gas Flow Status',
        value:  'Cubic Feet Per Minute (Cfm)',
        unitId: '13a96208-b342-46fe-b293-5c5395768b01'
    },
    { 
        id:     'Space Natural Gas Usage',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Space Power',
        value:  'Cubic Feet Per Minute (Cfm)',
        unitId: '13a96208-b342-46fe-b293-5c5395768b01'
    },
    { 
        id:     'Space Power Factor',
        value:  'Kilowatt (KW)',
        unitId: 'f147c894-0c59-41ad-85ec-f26b5a6315cf'
    },
    { 
        id:     'Space Resistance',
        value:  'Unitless ()',
        unitId: 'e9301189-9503-4ef1-aa07-72a14d949688'
    },
    { 
        id:     'Space Voltage',
        value:  'Ohm (Î©)',
        unitId: 'd41dc7fc-608c-4048-bcc4-42a9afe8ec61'
    },
    { 
        id:     'Space Water Flow',
        value:  'Volt (V)',
        unitId: 'ceffcac4-ab75-4906-9207-7b4693b304ef'
    },
    { 
        id:     'Space Water Flow Status',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Space Water Pressure',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Space Water Pressure High Limit',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Space Water Pressure Low Limit',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Space Water Usage',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Speed',
        value:  'Gallons Per Minute (Gal/Min)',
        unitId: '74497096-2815-426b-a708-c7b8e3e169b7'
    },
    { 
        id:     'Speed Command',
        value:  'Revolutions Per Minute (Rpm)',
        unitId: '20ede1b5-acbc-40fa-b2f5-f9864c750533'
    },
    { 
        id:     'Speed Max Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Speed Min Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Starts',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Status',
        value:  'Unitless ()',
        unitId: 'e9301189-9503-4ef1-aa07-72a14d949688'
    },
    { 
        id:     'Subcooling',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Superheat',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Supply Air CO',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Supply Air CO Deviation',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Supply Air CO High Limit',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Supply Air CO Max Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Supply Air CO Max Standby Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Supply Air CO Min Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Supply Air CO Min Standby Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Supply Air CO Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Supply Air CO Standby Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Supply Air CO2',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Supply Air CO2 Deviation',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Supply Air CO2 High Limit',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Supply Air CO2 Max Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Supply Air CO2 Max Standby Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Supply Air CO2 Min Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Supply Air CO2 Min Standby Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Supply Air CO2 Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Supply Air CO2 Standby Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Supply Air Dewpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Supply Air Dewpoint High Limit',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Supply Air Dewpoint Low Limit',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Supply Air Dewpoint Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Supply Air Enthalpy',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Supply Air Enthalpy Deviation',
        value:  'Btu Per Pound (BTU/Lb)',
        unitId: 'd9a10744-cdfb-48af-8766-6238d86a8aae'
    },
    { 
        id:     'Supply Air Enthalpy Max Setpoint',
        value:  'Btu Per Pound (BTU/Lb)',
        unitId: 'd9a10744-cdfb-48af-8766-6238d86a8aae'
    },
    { 
        id:     'Supply Air Enthalpy Max Standby Setpoint',
        value:  'Btu Per Pound (BTU/Lb)',
        unitId: 'd9a10744-cdfb-48af-8766-6238d86a8aae'
    },
    { 
        id:     'Supply Air Enthalpy Min Setpoint',
        value:  'Btu Per Pound (BTU/Lb)',
        unitId: 'd9a10744-cdfb-48af-8766-6238d86a8aae'
    },
    { 
        id:     'Supply Air Enthalpy Min Standby Setpoint',
        value:  'Btu Per Pound (BTU/Lb)',
        unitId: 'd9a10744-cdfb-48af-8766-6238d86a8aae'
    },
    { 
        id:     'Supply Air Enthalpy Setpoint',
        value:  'Btu Per Pound (BTU/Lb)',
        unitId: 'd9a10744-cdfb-48af-8766-6238d86a8aae'
    },
    { 
        id:     'Supply Air Enthalpy Standby Setpoint',
        value:  'Btu Per Pound (BTU/Lb)',
        unitId: 'd9a10744-cdfb-48af-8766-6238d86a8aae'
    },
    { 
        id:     'Supply Air Flow',
        value:  'Btu Per Pound (BTU/Lb)',
        unitId: 'd9a10744-cdfb-48af-8766-6238d86a8aae'
    },
    { 
        id:     'Supply Air Flow Cooling Setpoint',
        value:  'Cubic Feet Per Minute (Cfm)',
        unitId: '13a96208-b342-46fe-b293-5c5395768b01'
    },
    { 
        id:     'Supply Air Flow Deviation',
        value:  'Cubic Feet Per Minute (Cfm)',
        unitId: '13a96208-b342-46fe-b293-5c5395768b01'
    },
    { 
        id:     'Supply Air Flow Heating Setpoint',
        value:  'Cubic Feet Per Minute (Cfm)',
        unitId: '13a96208-b342-46fe-b293-5c5395768b01'
    },
    { 
        id:     'Supply Air Flow Max Cooling Setpoint',
        value:  'Cubic Feet Per Minute (Cfm)',
        unitId: '13a96208-b342-46fe-b293-5c5395768b01'
    },
    { 
        id:     'Supply Air Flow Max Heating Setpoint',
        value:  'Cubic Feet Per Minute (Cfm)',
        unitId: '13a96208-b342-46fe-b293-5c5395768b01'
    },
    { 
        id:     'Supply Air Flow Max Setpoint',
        value:  'Cubic Feet Per Minute (Cfm)',
        unitId: '13a96208-b342-46fe-b293-5c5395768b01'
    },
    { 
        id:     'Supply Air Flow Max Standby Cooling Setpoint',
        value:  'Cubic Feet Per Minute (Cfm)',
        unitId: '13a96208-b342-46fe-b293-5c5395768b01'
    },
    { 
        id:     'Supply Air Flow Max Standby Heating Setpoint',
        value:  'Cubic Feet Per Minute (Cfm)',
        unitId: '13a96208-b342-46fe-b293-5c5395768b01'
    },
    { 
        id:     'Supply Air Flow Max Standby Setpoint',
        value:  'Cubic Feet Per Minute (Cfm)',
        unitId: '13a96208-b342-46fe-b293-5c5395768b01'
    },
    { 
        id:     'Supply Air Flow Min Cooling Setpoint',
        value:  'Cubic Feet Per Minute (Cfm)',
        unitId: '13a96208-b342-46fe-b293-5c5395768b01'
    },
    { 
        id:     'Supply Air Flow Min Heating Setpoint',
        value:  'Cubic Feet Per Minute (Cfm)',
        unitId: '13a96208-b342-46fe-b293-5c5395768b01'
    },
    { 
        id:     'Supply Air Flow Min Setpoint',
        value:  'Cubic Feet Per Minute (Cfm)',
        unitId: '13a96208-b342-46fe-b293-5c5395768b01'
    },
    { 
        id:     'Supply Air Flow Min Standby Cooling Setpoint',
        value:  'Cubic Feet Per Minute (Cfm)',
        unitId: '13a96208-b342-46fe-b293-5c5395768b01'
    },
    { 
        id:     'Supply Air Flow Min Standby Heating Setpoint',
        value:  'Cubic Feet Per Minute (Cfm)',
        unitId: '13a96208-b342-46fe-b293-5c5395768b01'
    },
    { 
        id:     'Supply Air Flow Min Standby Setpoint',
        value:  'Cubic Feet Per Minute (Cfm)',
        unitId: '13a96208-b342-46fe-b293-5c5395768b01'
    },
    { 
        id:     'Supply Air Flow Setpoint',
        value:  'Cubic Feet Per Minute (Cfm)',
        unitId: '13a96208-b342-46fe-b293-5c5395768b01'
    },
    { 
        id:     'Supply Air Flow Standby Cooling Setpoint',
        value:  'Cubic Feet Per Minute (Cfm)',
        unitId: '13a96208-b342-46fe-b293-5c5395768b01'
    },
    { 
        id:     'Supply Air Flow Standby Heating Setpoint',
        value:  'Cubic Feet Per Minute (Cfm)',
        unitId: '13a96208-b342-46fe-b293-5c5395768b01'
    },
    { 
        id:     'Supply Air Flow Standby Setpoint',
        value:  'Cubic Feet Per Minute (Cfm)',
        unitId: '13a96208-b342-46fe-b293-5c5395768b01'
    },
    { 
        id:     'Supply Air Flow Status',
        value:  'Cubic Feet Per Minute (Cfm)',
        unitId: '13a96208-b342-46fe-b293-5c5395768b01'
    },
    { 
        id:     'Supply Air Methane',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Supply Air Methane Deviation',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Supply Air Methane High Limit',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Supply Air Methane Max Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Supply Air Methane Max Standby Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Supply Air Methane Min Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Supply Air Methane Min Standby Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Supply Air Methane Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Supply Air Methane Standby Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Supply Air O2',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Supply Air O2 Deviation',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Supply Air O2 Max Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Supply Air O2 Max Standby Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Supply Air O2 Min Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Supply Air O2 Min Standby Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Supply Air O2 Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Supply Air O2 Standby Setpoint',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Supply Air PM2.5',
        value:  'Parts Per Million (Ppm)',
        unitId: 'bb1d98a1-5e43-4460-abfb-51e7f0f6a5b9'
    },
    { 
        id:     'Supply Air PM2.5 Deviation',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Supply Air PM2.5 High Limit',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Supply Air PM2.5 Max Setpoint',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Supply Air PM2.5 Max Standby Setpoint',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Supply Air PM2.5 Min Setpoint',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Supply Air PM2.5 Min Standby Setpoint',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Supply Air PM2.5 Setpoint',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Supply Air PM2.5 Standby Setpoint',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Supply Air Pressure',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Supply Air Pressure Deviation',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Supply Air Pressure High Limit',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Supply Air Pressure High Limit Status',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Supply Air Pressure Low Limit',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Supply Air Pressure Low Limit Status',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Supply Air Pressure Max Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Supply Air Pressure Max Standby Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Supply Air Pressure Min Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Supply Air Pressure Min Standby Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Supply Air Pressure Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Supply Air Pressure Standby Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Supply Air Relative Humidity',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Supply Air Relative Humidity Deviation',
        value:  'Percent Relative Humidity (%RH)',
        unitId: '219d3f18-210d-448f-9bd8-814a496f6f94'
    },
    { 
        id:     'Supply Air Relative Humidity High Limit',
        value:  'Percent Relative Humidity (%RH)',
        unitId: '219d3f18-210d-448f-9bd8-814a496f6f94'
    },
    { 
        id:     'Supply Air Relative Humidity Low Limit',
        value:  'Percent Relative Humidity (%RH)',
        unitId: '219d3f18-210d-448f-9bd8-814a496f6f94'
    },
    { 
        id:     'Supply Air Relative Humidity Max Setpoint',
        value:  'Percent Relative Humidity (%RH)',
        unitId: '219d3f18-210d-448f-9bd8-814a496f6f94'
    },
    { 
        id:     'Supply Air Relative Humidity Max Standby Setpoint',
        value:  'Percent Relative Humidity (%RH)',
        unitId: '219d3f18-210d-448f-9bd8-814a496f6f94'
    },
    { 
        id:     'Supply Air Relative Humidity Min Setpoint',
        value:  'Percent Relative Humidity (%RH)',
        unitId: '219d3f18-210d-448f-9bd8-814a496f6f94'
    },
    { 
        id:     'Supply Air Relative Humidity Min Standby Setpoint',
        value:  'Percent Relative Humidity (%RH)',
        unitId: '219d3f18-210d-448f-9bd8-814a496f6f94'
    },
    { 
        id:     'Supply Air Relative Humidity Setpoint',
        value:  'Percent Relative Humidity (%RH)',
        unitId: '219d3f18-210d-448f-9bd8-814a496f6f94'
    },
    { 
        id:     'Supply Air Relative Humidity Standby Setpoint',
        value:  'Percent Relative Humidity (%RH)',
        unitId: '219d3f18-210d-448f-9bd8-814a496f6f94'
    },
    { 
        id:     'Supply Air Temperature',
        value:  'Percent Relative Humidity (%RH)',
        unitId: '219d3f18-210d-448f-9bd8-814a496f6f94'
    },
    { 
        id:     'Supply Air Temperature Cooling Deadband',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Supply Air Temperature Cooling Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Supply Air Temperature Deadband',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Supply Air Temperature Deviation',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Supply Air Temperature Heating Deadband',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Supply Air Temperature Heating Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Supply Air Temperature High Limit',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Supply Air Temperature Low Limit',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Supply Air Temperature Max Cooling Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Supply Air Temperature Max Heating Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Supply Air Temperature Max Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Supply Air Temperature Max Standby Cooling Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Supply Air Temperature Max Standby Heating Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Supply Air Temperature Max Standby Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Supply Air Temperature Min Cooling Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Supply Air Temperature Min Heating Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Supply Air Temperature Min Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Supply Air Temperature Min Standby Cooling Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Supply Air Temperature Min Standby Heating Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Supply Air Temperature Min Standby Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Supply Air Temperature Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Supply Air Temperature Standby Cooling Deadband',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Supply Air Temperature Standby Cooling Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Supply Air Temperature Standby Deadband',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Supply Air Temperature Standby Heating Deadband',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Supply Air Temperature Standby Heating Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Supply Air Temperature Standby Setpoint',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Supply Air TVOC',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Supply Air TVOC Deviation',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Supply Air TVOC High Limit',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Supply Air TVOC Max Setpoint',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Supply Air TVOC Max Standby Setpoint',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Supply Air TVOC Min Setpoint',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Supply Air TVOC Min Standby Setpoint',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Supply Air TVOC Setpoint',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Supply Air TVOC Standby Setpoint',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Supply Air Wet Bulb',
        value:  'User Defined',
        unitId: null
    },
    { 
        id:     'Supply Air Wet Bulb High Limit',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Supply Air Wet Bulb Low Limit',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Supply Damper Open Command',
        value:  'Fahrenheit (Â°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Supply Damper Open Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Supply Damper Position',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Supply Damper Position Command',
        value:  'Percentage (%)',
        unitId: 'bd1f4749-9598-4c27-b879-073e6783a775'
    },
    { 
        id:     'Supply Damper Position Max Command',
        value:  'Percentage (%)',
        unitId: 'bd1f4749-9598-4c27-b879-073e6783a775'
    },
    { 
        id:     'Supply Damper Position Min Command',
        value:  'Percentage (%)',
        unitId: 'bd1f4749-9598-4c27-b879-073e6783a775'
    },
    { 
        id:     'Supply Fan 1 Alarm',
        value:  'Percentage (%)',
        unitId: 'bd1f4749-9598-4c27-b879-073e6783a775'
    },
    { 
        id:     'Supply Fan 2 Alarm',
        value:  'Alarm',
        unitId: null
    },
    { 
        id:     'Supply Fan Command',
        value:  'Alarm',
        unitId: null
    },
    { 
        id:     'Supply Fan Current',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Supply Fan Electric Usage',
        value:  'Ampere (A)',
        unitId: '07515d1e-c260-42d9-81b5-cfd65c66d7cf'
    },
    { 
        id:     'Supply Fan Frequency',
        value:  'Kilowatt Hour (KWh)',
        unitId: 'eb844ee5-8420-4829-b57e-daa8547f5e3c'
    },
    { 
        id:     'Supply Fan Horsepower',
        value:  'Hertz (Hz)',
        unitId: 'e4ef5692-143b-4102-9cd3-b3cc4ce0216b'
    },
    { 
        id:     'Supply Fan Power',
        value:  'Horsepower (Hp)',
        unitId: 'bb7650f1-d12e-4253-9efb-7b6d3867cda5'
    },
    { 
        id:     'Supply Fan Power Factor',
        value:  'Kilowatt (KW)',
        unitId: 'f147c894-0c59-41ad-85ec-f26b5a6315cf'
    },
    { 
        id:     'Supply Fan Resistance',
        value:  'Unitless ()',
        unitId: 'e9301189-9503-4ef1-aa07-72a14d949688'
    },
    { 
        id:     'Supply Fan RPM',
        value:  'Ohm (Î©)',
        unitId: 'd41dc7fc-608c-4048-bcc4-42a9afe8ec61'
    },
    { 
        id:     'Supply Fan Runtime',
        value:  'Revolutions Per Minute (Rpm)',
        unitId: '20ede1b5-acbc-40fa-b2f5-f9864c750533'
    },
    { 
        id:     'Supply Fan Speed',
        value:  'Second (Sec)',
        unitId: 'b0f5c0ad-8643-489b-90f7-f0a75fc4fe76'
    },
    { 
        id:     'Supply Fan Speed Command',
        value:  'Revolutions Per Minute (Rpm)',
        unitId: '20ede1b5-acbc-40fa-b2f5-f9864c750533'
    },
    { 
        id:     'Supply Fan Speed Max Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Supply Fan Speed Min Command',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Supply Fan Starts',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Supply Fan Status',
        value:  'Unitless ()',
        unitId: 'e9301189-9503-4ef1-aa07-72a14d949688'
    },
    { 
        id:     'Supply Fan Voltage',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Supply Steam Pressure',
        value:  'Volt (V)',
        unitId: 'ceffcac4-ab75-4906-9207-7b4693b304ef'
    },
    { 
        id:     'Supply Steam Pressure Deviation',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Supply Steam Pressure High Limit',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Supply Steam Pressure Low Limit',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Supply Steam Pressure Max Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Supply Steam Pressure Min Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Supply Steam Pressure Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Supply Valve Open Command',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Supply Valve Open Status',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Supply Valve Position',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Supply Valve Position Command',
        value:  'Percentage (%)',
        unitId: 'bd1f4749-9598-4c27-b879-073e6783a775'
    },
    { 
        id:     'Supply Valve Position Max Command',
        value:  'Percentage (%)',
        unitId: 'bd1f4749-9598-4c27-b879-073e6783a775'
    },
    { 
        id:     'Supply Valve Position Min Command',
        value:  'Percentage (%)',
        unitId: 'bd1f4749-9598-4c27-b879-073e6783a775'
    },
    { 
        id:     'Supply Water Flow',
        value:  'Percentage (%)',
        unitId: 'bd1f4749-9598-4c27-b879-073e6783a775'
    },
    { 
        id:     'Supply Water Flow Deviation',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Supply Water Flow Max Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Supply Water Flow Min Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Supply Water Flow Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Supply Water Flow Status',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Supply Water Pressure',
        value:  'Boolean',
        unitId: null
    },
    { 
        id:     'Supply Water Pressure Deviation',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Supply Water Pressure High Limit',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Supply Water Pressure Low Limit',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Supply Water Pressure Max Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Supply Water Pressure Min Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Supply Water Pressure Setpoint',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Supply Water Temperature',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Supply Water Temperature Cooling Deadband',
        value:  'Fahrenheit (°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Supply Water Temperature Cooling Setpoint',
        value:  'Fahrenheit (°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Supply Water Temperature Deadband',
        value:  'Fahrenheit (°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Supply Water Temperature Deviation',
        value:  'Fahrenheit (°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Supply Water Temperature Heating Deadband',
        value:  'Fahrenheit (°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Supply Water Temperature Heating Setpoint',
        value:  'Fahrenheit (°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Supply Water Temperature High Limit',
        value:  'Fahrenheit (°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Supply Water Temperature Low Limit',
        value:  'Fahrenheit (°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Supply Water Temperature Max Cooling Setpoint',
        value:  'Fahrenheit (°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Supply Water Temperature Max Heating Setpoint',
        value:  'Fahrenheit (°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Supply Water Temperature Max Setpoint',
        value:  'Fahrenheit (°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Supply Water Temperature Min Cooling Setpoint',
        value:  'Fahrenheit (°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Supply Water Temperature Min Heating Setpoint',
        value:  'Fahrenheit (°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Supply Water Temperature Min Setpoint',
        value:  'Fahrenheit (°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Supply Water Temperature Setpoint',
        value:  'Fahrenheit (°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Supply Water Usage',
        value:  'Fahrenheit (°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Terminal Load',
        value:  'Gallons Per Minute (Gal/Min)',
        unitId: '74497096-2815-426b-a708-c7b8e3e169b7'
    },
    { 
        id:     'Total Organic Compounds Sensor',
        value:  'Percentage (%)',
        unitId: 'bd1f4749-9598-4c27-b879-073e6783a775'
    },
    { 
        id:     'Total Organic Compounds Setpoint',
        value:  'Parts Per Billion (Ppb)',
        unitId: '3bbb284f-a21a-43e1-9685-cf6ebd6673c7'
    },
    { 
        id:     'Total Runtime',
        value:  'Parts Per Billion (Ppb)',
        unitId: '3bbb284f-a21a-43e1-9685-cf6ebd6673c7'
    },
    { 
        id:     'Unoccupied Air Changes Setpoint',
        value:  'Second (Sec)',
        unitId: 'b0f5c0ad-8643-489b-90f7-f0a75fc4fe76'
    },
    { 
        id:     'VFD Alarm Status',
        value:  'Air Changes Per Hour (ACH)',
        unitId: '43badf12-29ea-411e-b119-270ae9ca28f7'
    },
    { 
        id:     'Voltage',
        value:  'Alarm',
        unitId: null
    },
    { 
        id:     'Volume',
        value:  'Volt (V)',
        unitId: 'ceffcac4-ab75-4906-9207-7b4693b304ef'
    },
    { 
        id:     'Water Coil Entering Temperature',
        value:  'Unitless ()',
        unitId: 'e9301189-9503-4ef1-aa07-72a14d949688'
    },
    { 
        id:     'Water Coil Leaving Temperature',
        value:  'Fahrenheit (°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Water Filter Alarm Status',
        value:  'Fahrenheit (°F)',
        unitId: '662383ce-4861-48a8-a9a0-e87a48ce29b1'
    },
    { 
        id:     'Water Filter Alarm Status Enum',
        value:  'Alarm',
        unitId: null
    },
    { 
        id:     'Water Filter Alarm Text',
        value:  'Alarm',
        unitId: null
    },
    { 
        id:     'Water Filter Differential Pressure',
        value:  'Alarm',
        unitId: null
    },
    { 
        id:     'Water Filter Differential Pressure High Limit',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Water Filter Differential Pressure Low Limit',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Water Level',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Water Prefilter Alarm Status',
        value:  'Unitless ()',
        unitId: 'e9301189-9503-4ef1-aa07-72a14d949688'
    },
    { 
        id:     'Water Prefilter Alarm Status Enum',
        value:  'Alarm',
        unitId: null
    },
    { 
        id:     'Water Prefilter Alarm Text',
        value:  'Alarm',
        unitId: null
    },
    { 
        id:     'Water Prefilter Differential Pressure',
        value:  'Alarm',
        unitId: null
    },
    { 
        id:     'Water Prefilter Differential Pressure High Limit',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    },
    { 
        id:     'Water Prefilter Differential Pressure Low Limit',
        value:  'Inches Of Water (in/wc)',
        unitId: '52473405-b035-4970-a701-e6dc5834a227'
    }
];
